export const YEAR = 2026;
export const Status = {
  MISSING: "MISSING",
  PENDING: "PENDING",
  PENDING2: "PENDING2",
  WAITFORPROXY: "WAITFORPROXY",
  WAITFORSUPERVISOR: "WAITFORSUPERVISOR",
  PROXYSUBMITTED: "PROXYSUBMITTED",
  SUPERVISORSUBMITTED: "SUPERVISORSUBMITTED",
  WAITFORSTAFF: "WAITFORSTAFF",
  STAFFREVIEWED: "STAFFREVIEWED",
  CLOSED: "CLOSED",
};

export const YESNOPARTIAL = {
  YES: "YES",
  NO: "NO",
  PARTIAL: "PARTIAL",
};

export const YESNO = {
  YES: "YES",
  NO: "NO",
};

export const scores = [
  { grade: 0, score: 0 },
  { grade: 1, score: 30 },
  { grade: 2, score: 50 },
  { grade: 3, score: 70 },
  { grade: 4, score: 85 },
  { grade: 5, score: 100 },
];
export const QuestionNos = {
  One: "1.0",
  Two: "2.0",
  Three: "3.0",
  Four: "4.0",
  Five: "5.0",
  Six: "6.0",
  Seven: "7.0",
  Eight: "8.0",
};
export const Trainings = {
  ProblemSolving: "Problem Solving",
  DecisionMaking: "Decision Making",
  CriticalThinkingSkills: "Critical Thinking Skills",
  MasteringEmotionalIntelligence: "Mastering Emotional Intelligence",
  EffectiveInterpersonalSkill: "Effective Interpersonal Skill",
  SupervisorySkill: "Supervisory Skill",
  LeadershipSkill: "Leadership Skill",
  QualityManagementSystem: "Quality Management System",
  StressManagement: "Stress Management",
  OrganizationSkill: "Organization Skill",
  BusinessEnglishSkill: "Business English Skill",
  PresentationSkill: "Presentation Skill",
  ComputerLiteracy: "Computer Literacy",
  OfficeProductivitySpreadsheet: "Office Productivity – Spreadsheet",
  OfficeProductivityDocument: "Office Productivity – Document",
};
export const SupervisorFormMode = {
  FINDUSER: "FINDUSER",
  ASSIGNSUPERVISOR: "ASSIGNSUPERVISOR",
};
export const SCORECOLORS = {
  Lime: "#00FF00",
  LawnGreen: "#7CFC00",
  GreenYellow: "#ADFF2F",
  Yellow: "#FFFF00",
  Gold: "#FFD700",
  LightSalmon: "#FFA07A",
};

export const StatusColor = {
  MISSING: "Gray",
  PENDING: "LightYellow",
  WAITFORSUPERVISOR: "Yellow",
  WAITFORPROXY: "Yellow" /* suspected unused */,
  PROXYSUBMITTED: "Red",
  SUPERVISORSUBMITTED: "Blue",
  WAITFORSTAFF: "LightCyan",
  STAFFREVIEWED: "Green",
  CLOSED: "LightGray",
};
export const StatusColor2 = {
  MISSING: "Gray",
  PENDING: "LightYellow",
  WAITFORSUPERVISOR: "Yellow",
  PROXYSUBMITTED: "Red",
  SUPERVISORSUBMITTED: "LightCyan",
  WAITFORSTAFF: "LightCyan",
  STAFFREVIEWED: "LawnGreen",
  CLOSED: "LightGray",
};
export const LISTVIEW = {
  LIST: "LIST",
  VIEW: "VIEW",
};
export const LISTCOMPANYDEPARTMENT = {
  LIST: "LIST",
  COMPANY: "COMPANY",
  DEPARTMENT: "DEPARTMENT",
};
export const APPTITLE = "Staff Annual Performance Evaluation for 2026";
export const NOTRELEVANT = "NOTRELEVANT";

export const APPRAISERS = [
{staff: `RITCHDINI JUNIAN ANAK FREDDIE`, proxy: ``, appraiser: `ABRAHAM CHUANG-CHYI TIONG`},
{staff: `CHAI YI THUNG, CARSON`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `FREDERICK CABUNGAN BANAWA`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `JONG SUK FANG`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `LENOR JOYCE SASOY LEGASPI-BANAWA`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `LIEW SZE YAH, NICOLE`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `NGO KEH TOH, ANNIE`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `OW WAN FOO, EDDIE`, proxy: ``, appraiser: `ALVIN CHONG TZE HUI`},
{staff: `DORIS ANAK WILSON ELAH`, proxy: ``, appraiser: `ARCHIBAL CATIBOG MANANSALA`},
{staff: `HO AI CHIN`, proxy: ``, appraiser: `ARCHIBAL CATIBOG MANANSALA`},
{staff: `NORSAMSUDDIN ANAK BANGUN`, proxy: ``, appraiser: `ARCHIBAL CATIBOG MANANSALA`},
{staff: `SITI HAJAR BINTI MOHD YUSOP`, proxy: ``, appraiser: `ARCHIBAL CATIBOG MANANSALA`},
{staff: `ELLYZA EZLYN BINTI BLAISE`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `JENNY YU PICK HAI`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `STEPHEN TAN SOON HONG`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `TAN KOK SAN, NICOLE`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `TANG LING PING, JENNIFER`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `TAY CHIOK KEE`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `TIONG TECK YIENG`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `YONG SERN PIAT`, proxy: ``, appraiser: `AUGUSTINE LAW SEK HIAN`},
{staff: `AZALIZA BINTI AMIN`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `ELLY ANAK WILFRED`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `HELMI BIN PUTEH`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `MARCOS ANAK WARREN SAOH`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `NGUANG KIM KIONG`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `NORBAYU BT MUKU`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `SABREE BIN SABU`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `VERONICA A/P NOED`, proxy: ``, appraiser: `BONG IT FIAN, IVAN`},
{staff: `DIANA LEE MEI MEI`, proxy: ``, appraiser: `CHAN HOOD SOO`},
{staff: `HASNIYATI HII BINTI ABDULLAH`, proxy: ``, appraiser: `CHAN HOOD SOO`},
{staff: `KATHERINE YII JOU PEI`, proxy: ``, appraiser: `CHAN HOOD SOO`},
{staff: `LAI CHEAU NEE`, proxy: ``, appraiser: `CHAN HOOD SOO`},
{staff: `LIM WEI SING`, proxy: ``, appraiser: `CHAN HOOD SOO`},
{staff: `SYLVIA TANG CHUNG TIEN`, proxy: ``, appraiser: `CHAN HOOD SOO`},
{staff: `ALAUDDIN BIN OTHMAN`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `BONG ZHANG YING`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `JULIAN ACHOI ANAK GANA`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `MARVIN TARANG ANAK EDWARD`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `NICHOLAS ANAK JANNIES`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `RICKFIELD GEWONG`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `ROSLAN BIN ROSLI`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `CAMILLA MARCIA KEDUAK ANAK UNYUK`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `CLINTON JAWA ANAK RICHARDLY`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `COLIN MATHEW`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `GARY MADANG ANAK UNDOM`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `MAGDALYNE LIZA UBANG`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `MOHAMAD HATTA BIN ROSIDI`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `MUHAMMAD BIN SARIP`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `SUTIANA ANAK JESUT`, proxy: ``, appraiser: `CHARLES LEE WEE TECK`},
{staff: `LAU SIE CHUNG`, proxy: ``, appraiser: `CHEE SIAW PAW`},
{staff: `TING SII KIONG`, proxy: ``, appraiser: `CHEE SIAW PAW`},
{staff: `CHRIS BRYAN ANAK NAWOT`, proxy: ``, appraiser: `CHIN YIAN CHON, ALSON`},
{staff: `FRAVELLYN LYNDAI ANAK BUMA`, proxy: ``, appraiser: `CHIN YIAN CHON, ALSON`},
{staff: `CHIN CHEE HAO`, proxy: ``, appraiser: `CHIN YIAN CHON, ALSON`},
{staff: `LEE JIE LING`, proxy: ``, appraiser: `CHIN YIAN CHON, ALSON`},
{staff: `LIM KIAN BENG`, proxy: ``, appraiser: `CHIN YIAN CHON, ALSON`},
{staff: `MUHAMMAD ALFIAN WIRA SEPTIAN`, proxy: ``, appraiser: `CHIN YIAN CHON, ALSON`},
{staff: `MARDHIAH BINTI WAHID`, proxy: ``, appraiser: `FREDERICK CABUNGAN BANAWA`},
{staff: `CHUA SIAW TED`, proxy: ``, appraiser: `FREDERICK CABUNGAN BANAWA`},
{staff: `LESTINLEY LUIS ANAK LAWAI`, proxy: ``, appraiser: `FREDERICK CABUNGAN BANAWA`},
{staff: `SHIRLEY WONG LEE SAN`, proxy: ``, appraiser: `FREDERICK CABUNGAN BANAWA`},
{staff: `ANGELA WONG SIEW MEE`, proxy: ``, appraiser: `HENG MUI KEE`},
{staff: `LORRAINE LIEW WOON FUNG`, proxy: ``, appraiser: `HENG MUI KEE`},
{staff: `ELSIE LEE SUK CHER`, proxy: ``, appraiser: `HENG MUI KEE`},
{staff: `EVELYN ANAK ANAU`, proxy: ``, appraiser: `HENG MUI KEE`},
{staff: `HANNA SANTARINA ANAK MAURICE`, proxy: ``, appraiser: `HON JUN KHIONG`},
{staff: `KO LIAN CHUENG, KENNETH`, proxy: ``, appraiser: `HON JUN KHIONG`},
{staff: `LAI SIEW LIEN`, proxy: ``, appraiser: `HON JUN KHIONG`},
{staff: `MAC AUBREY ANAK MORIS @ MICHAEL`, proxy: ``, appraiser: `HON JUN KHIONG`},
{staff: `JONG QIAO XUAN`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `BONG JOO CHEE`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `DAUD BIN MAHMOR`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `LAW DUEN SIONG`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `NANCY THU MEI SZE`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `NG WAN LI, WENDY`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `NUR ASFIA BIN MOHAMAD DOLLAH`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `TAY GUAN PHING`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `WEE GUEK YIAN`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `WEI SZE NEI`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `YUSUF BIN BAHARI`, proxy: ``, appraiser: `JENNY YU PICK HAI`},
{staff: `LEE PING CHIONG`, proxy: ``, appraiser: `JIMENO JR. LUGUE JERUSALEM`},
{staff: `MELISA ANAK SURING`, proxy: ``, appraiser: `JIMENO JR. LUGUE JERUSALEM`},
{staff: `MUHAMMAD AMIRUL RIDHZUAN STANNY`, proxy: ``, appraiser: `JIMENO JR. LUGUE JERUSALEM`},
{staff: `TING YING SIEW`, proxy: ``, appraiser: `JIMENO JR. LUGUE JERUSALEM`},
{staff: `DARREN JOSHUA LUNA ANAK MARVIN @ IMPI`, proxy: ``, appraiser: `JOEL SU TAI TUNG`},
{staff: `ADEEBA ATHIRA BINTI BERAHIM`, proxy: ``, appraiser: `JONG SIAW FOONG, STEVEN`},
{staff: `DESMOND LEE TONG HOWE`, proxy: ``, appraiser: `JONG SIAW FOONG, STEVEN`},
{staff: `CALVIN GARAN ANAK GOHAN`, proxy: ``, appraiser: `JONG SIAW FOONG, STEVEN`},
{staff: `LING NGIE LEE, KELVIN`, proxy: ``, appraiser: `JULIAN LAU KHERR LOONG`},
{staff: `SIM YUH SHIUN`, proxy: ``, appraiser: `JULIAN LAU KHERR LOONG`},
{staff: `CHRISTOPHER CHAI KOH WEE`, proxy: ``, appraiser: `KATHERINE SONG`},
{staff: `VELDA CHANG CHIA YIN`, proxy: ``, appraiser: `KATHERINE SONG`},
{staff: `ABDUL WARITH BIN MOHAMMAD PHILIP`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `ARCHIBAL CATIBOG MANANSALA`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `CHAI CHANG LECK, ERIC`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `CHIANG HENG HO`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `CHONG YU CHIAU`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `CHRIS HUDSON ANAK BUJANG`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `KELVIN CHAI HOCK JOI`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `LEE KUET LUNG`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `LIM KAI HENG`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `SELINBIT ANAK MOS`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `TOH JAG HUI`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `TULIS ANAK CHANDANG`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `VIVIANA ONG ZHI JINN`, proxy: ``, appraiser: `KELVIN KANG KIAN LAI`},
{staff: `LIEW HOCK RUI`, proxy: ``, appraiser: `KELVIN YII SENG HUA`},
{staff: `TIBU ANAK DAUD`, proxy: ``, appraiser: `KELVIN YII SENG HUA`},
{staff: `ALVIN CHONG TZE HUI`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `CHAN HOOD SOO`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `CHIN YIAN CHON, ALSON`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `CHINDAI ANAK JOSEPH`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `HENG MUI KEE`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `HON JUN KHIONG`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `JIMENO JR. LUGUE JERUSALEM`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `JONG SIAW FOONG, STEVEN`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `KELVIN KANG KIAN LAI`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `KELVIN YII SENG HUA`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `LAU YUK SIONG, PHILIP`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `SIAW WEN YIAP, MICHEAL`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `SIM KAY CHIAN, STEPHEN`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `TING SING HWA`, proxy: ``, appraiser: `LAU KIING KANG, SIMON`},
{staff: `JULIAN LAU KHERR LOONG`, proxy: ``, appraiser: `LAU YUK SIONG, PHILIP`},
{staff: `LAU KIEW HING`, proxy: ``, appraiser: `LAU YUK SIONG, PHILIP`},
{staff: `SIEW MING HUA`, proxy: ``, appraiser: `LAU YUK SIONG, PHILIP`},
{staff: `SIM YIK CHWIN`, proxy: ``, appraiser: `LAU YUK SIONG, PHILIP`},
{staff: `ANDYANNA ANAK ADRIS`, proxy: ``, appraiser: `LAWRENCE KONG`},
{staff: `JASCICA ANAK BAJAK`, proxy: ``, appraiser: `LESLIE LIM CHUNG LEONG`},
{staff: `BOBIC IZACK ANAK RAJINOK`, proxy: ``, appraiser: `LING NGIE LEE, KELVIN`},
{staff: `CYNTHIA TANG JOCK YUN`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `MICHELLE HON XUE YUN`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `VANESSA TING MEE JIUN`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `VIONNIE CHIEW SIEW LING`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `VOON LIK YONG`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `WENDY CHONG LEE YA`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `YAP LI LI`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `YASMINE FATHIAH BINTI MOHD DEXTER HOWELL`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `BELINDA TAN CHAI YING`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `BILLY JONG HUNG ENG`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `CHONG UU LEONG, ZACK`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `EMILY ANAK USAM`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `HELY ANAK SOTIN`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `JOEL SU TAI TUNG`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `JOSEPHINE FOO SIEW PHENG`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `LIM SOO HUI`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `LING SHI HING, ERIC`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `MARIA JATTI ANAK ENA`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `MARIA SU`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `OLIZARENA ANAK ENA`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `THON HUI HUI`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `TIONG SIEW LING`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `VOON SAY NYUK, SHIRLEY`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `WAN MOHAMAD BIN WAN ALLI`, proxy: ``, appraiser: `SIA SOON GUEI`},
{staff: `BONG MEI LUN`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `IDZWAN HAKIMI BIN TAHIR`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `CHIENG CHING KUOK`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `CHIENG SHAW YAW`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `CHONG CHIA WEI`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `DAVIDSON AK DAYUT`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `FLONY MEREH ANAK DAVID`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `GOH CHIN SING`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `JACKLYN ANAK JUGAH`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `PERNANDEZ TULIS`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `SYLVESTER MIKE LIEW CHO KEAT`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `TANG SING HUI`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `TEO TAI WEE, STEPHEN`, proxy: ``, appraiser: `SIAW WEN YIAP, MICHEAL`},
{staff: `ARIF BIN CHIK`, proxy: ``, appraiser: `SIEW MING HUA`},
{staff: `MOHAMMAD AZEIR BIN UMIN`, proxy: ``, appraiser: `SIEW MING HUA`},
{staff: `RUSWAN ASWARI BIN YAHYA`, proxy: ``, appraiser: `SIEW MING HUA`},
{staff: `PRESCILLIA ANAK PHILIP`, proxy: ``, appraiser: `SIM YIK CHWIN`},
{staff: `FIODA LEW SHIN YII`, proxy: ``, appraiser: `SYLVIA ANAK CHAONG`},
{staff: `CHRISTIANA ROMINA ANAK JANIS`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `DAYANG NUR AININA BINTI ABG MOHAMAD`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `FADILLAH BTE ABDULLAH`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `HII CHUI YEN, IVY`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `MONA KEDAYA ANAK STORY`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `NAJA ANAK NYAUN`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `SANDRA ANAK JAWING`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `SONIA VIVIANI ANAK JANIS`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `TING SIAW WEE`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `VOON KHENG HUA, VALERIE`, proxy: ``, appraiser: `TAN KOK SAN, NICOLE`},
{staff: `AMINAH BINTI ABIDIN`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `CHAI JIEW LEONG`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `ADRIAN CHAI YOU QING`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `HO SIAW LEE, LILY`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `IRENE KHO AI LING`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `IRWAN BIN BUJANG`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `JOYCE LIM FAYE`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `TANG KUI SIEW, DEBBY`, proxy: ``, appraiser: `TANG LING PING, JENNIFER`},
{staff: `ANDRESS LANTUK ANAK MAJING`, proxy: `ALEXANDER LAI HORNG WEN`, appraiser: `TAY CHIOK KEE`},
{staff: `WINNIE LAI EE FEI`, proxy: `ALEXANDER LAI HORNG WEN`, appraiser: `TAY CHIOK KEE`},
{staff: `HII YII SHIN`, proxy: `LESLIE LIM CHUNG LEONG`, appraiser: `TAY CHIOK KEE`},
{staff: `ABDUL AZIZ BIN HIPENI`, proxy: `TAN YIEN LIN`, appraiser: `TAY CHIOK KEE`},
{staff: `ALYSSA ASONG SIMON`, proxy: `THIAN FUI CHIUN, KERRY`, appraiser: `TAY CHIOK KEE`},
{staff: `LINDA ANAK BUYONG`, proxy: `VICTORIA ANAK UMPANG`, appraiser: `TAY CHIOK KEE`},
{staff: `VICTORIA ANAK UMPANG`, proxy: `YEO TANG TANG`, appraiser: `TAY CHIOK KEE`},
{staff: `AARON AU SAU SIANG`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `ALEXANDER LAI HORNG WEN`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `ANGIE JOAN ANAK DANIEL`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `CHARLES LEE WEE TECK`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `CHARLES REYNOLD ANAK NIGEL`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `CHONG SIAW HUA`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `FARAHANI BINTI HAINI`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `LAI SIAW LING`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `LESLIE LIM CHUNG LEONG`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `LING SHEAU WEI`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `NGO JIN JIN`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `PHANG MING JING, RAINIE`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `SHARON NG KHE SWYN`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `TAN YIEN LIN`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `THIAN FUI CHIUN, KERRY`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `TIE SHIE LING`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `TIEO SEOW LING, LYN`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `TING KWAN HEE`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `YEO TANG TANG`, proxy: ``, appraiser: `TAY CHIOK KEE`},
{staff: `ALBINUS PETRUS RATIM NGIBAN`, proxy: ``, appraiser: `TING KWAN HEE`},
{staff: `ALI BIN SABRI`, proxy: ``, appraiser: `TING KWAN HEE`},
{staff: `BONNIE ANAK ANTHONY`, proxy: ``, appraiser: `TING KWAN HEE`},
{staff: `HAIDI BIN MARANI`, proxy: ``, appraiser: `TING KWAN HEE`},
{staff: `TUNI ANAK OUI JUAN`, proxy: ``, appraiser: `TING KWAN HEE`},
{staff: `JOHAN ANAK JAWA`, proxy: ``, appraiser: `TING SING HWA`},
{staff: `CHOO ZONGWEI`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CHUA YONG TIEN, EUNICE`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CINDY CHONG LEE MING`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `JONG HUI WOON`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `LAU LI KUO`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `MICHELLE WONG XIU HAN`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `NG KHOON CHIENG`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `SOH MEI XING`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `TAN KAH HO, LEON`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `VANESSA TAY MING FONG`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `JOYCE TEH YEE`, proxy: `CHAI SIN HWEI`, appraiser: `TIONG TECK YIENG`},
{staff: `TERRY THAM TZE PING`, proxy: `CHAI SIN HWEI`, appraiser: `TIONG TECK YIENG`},
{staff: `TAY YI YING`, proxy: `CHONG SIAW HUA`, appraiser: `TIONG TECK YIENG`},
{staff: `JACKUELINE ONG YUEN CHING`, proxy: `LIM EK HUA`, appraiser: `TIONG TECK YIENG`},
{staff: `ONG CHIAW SIAN`, proxy: `LIM EK HUA`, appraiser: `TIONG TECK YIENG`},
{staff: `ANNIE LEE SIEW PHIN`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CHAI LI SWAN`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CHAI PEI SHAN`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CHAI SIN HWEI`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CHIN JIUN HUAH, ANGEL`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `CHRISTABELLA DUIE ANAK CHRISTOPHER NYENGGANG`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `JANICE ANG CI XIA`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `JI CHOU KING`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `KHO BOON POH`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `LIM EK HUA`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `ONG CHIEW LING`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `SIA SOON GUEI`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `SIM PEI CHUN`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `SIM SIAT FUNG, ALICE`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `TAN MIAW ENG, ANGELINE`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `WONG WOAN MIING, RACHELLE`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `YONG TING`, proxy: ``, appraiser: `TIONG TECK YIENG`},
{staff: `VOON JIEW MIN`, proxy: ``, appraiser: `TONY YU YUONG WEE`},
{staff: `BONG IT FIAN, IVAN`, proxy: ``, appraiser: `TONY YU YUONG WEE`},
{staff: `CHEE SIAW PAW`, proxy: ``, appraiser: `TONY YU YUONG WEE`},
{staff: `KHO HO SIA, GEORGE`, proxy: ``, appraiser: `TONY YU YUONG WEE`},
{staff: `WONG MING`, proxy: ``, appraiser: `TONY YU YUONG WEE`},
{staff: `MOHD SHAHRUL SHAH FENDI HENDY DVAI`, proxy: ``, appraiser: `WONG MING`},
{staff: `REMY ANAK JOHEL`, proxy: `JOEL SU TAI TUNG`, appraiser: `WONG MING`},
{staff: `FABIANA ANAK CHAN`, proxy: `KHO HO SIA, GEORGE`, appraiser: `WONG MING`},
{staff: `LIEGAN ANAK MANGGUH`, proxy: `KHO HO SIA, GEORGE`, appraiser: `WONG MING`},
{staff: `NOOR MARLIDAH HAI`, proxy: `KHO HO SIA, GEORGE`, appraiser: `WONG MING`},
{staff: `BRIGETTE BRENDA BASE`, proxy: ``, appraiser: `WONG MING`},
{staff: `CHENDANG ANAK THOMAS ALI`, proxy: ``, appraiser: `WONG MING`},
{staff: `CHIN LEE HUA`, proxy: ``, appraiser: `WONG MING`},
{staff: `DIANA BIDAI ANAK MENDALI`, proxy: ``, appraiser: `WONG MING`},
{staff: `JOHNNY HO KOK SIAM`, proxy: ``, appraiser: `WONG MING`},
{staff: `JONG KIM WONG`, proxy: ``, appraiser: `WONG MING`},
{staff: `JULLYANA GORILA ANAK JENOS`, proxy: ``, appraiser: `WONG MING`},
{staff: `LESTER LUNA ANAK ULOK`, proxy: ``, appraiser: `WONG MING`},
{staff: `MAINA NICKOLA ANAK MICHILE`, proxy: ``, appraiser: `WONG MING`},
{staff: `NELVIN BRIAN ANAK NAWOT`, proxy: ``, appraiser: `WONG MING`},
{staff: `NURUL HURAIRAH BINTI SARIP`, proxy: ``, appraiser: `WONG MING`},
{staff: `SYLVESTER ANAK KENETH KANYAN`, proxy: ``, appraiser: `WONG MING`},
{staff: `VERONICA SULAN ANAK VINCENT`, proxy: ``, appraiser: `WONG MING`},
{staff: `VORNICA NAYAN ANAK NANANG`, proxy: ``, appraiser: `WONG MING`},
{staff: `EDWARD TENLEY AK FRANCIS KETIR`, proxy: ``, appraiser: `YEO TANG TANG`},
{staff: `YUNG MEI HUA, MANDY`, proxy: ``, appraiser: `YEO TANG TANG`},
{staff: `GASTON QION EMMANUEL AK GEORGE`, proxy: ``, appraiser: `YONG SERN PIAT`},
{staff: `LO JAK FATT, EVENCE`, proxy: ``, appraiser: `YONG SERN PIAT`},
{staff: `TAN KEENG LING`, proxy: ``, appraiser: `YONG SERN PIAT`},
{staff: `YONG WEI TING`, proxy: ``, appraiser: `YONG SERN PIAT`},
{staff: `ABRAHAM CHUANG-CHYI TIONG`, proxy: ``, appraiser: `YU JI`},
{staff: `KATHERINE SONG`, proxy: ``, appraiser: `YU JI`},
{staff: `SYLVIA ANAK CHAONG`, proxy: ``, appraiser: `YU JI`},
{staff: `YVONNE SHARON ANAK MIKOLDEN`, proxy: ``, appraiser: `YU JI`}
]

export const DEPARTMENTS = [ { name: "ACCOUNTS", departmentid: "ACC" }, { name: "ADMINISTRATION", departmentid: "ADM" }, { name: "BPL", departmentid: "BPL" }, { name: "CORPORATION", departmentid: "CORP" }, { name: "HR", departmentid: "HR" }, { name: "HR & CORPORATE COMM", departmentid: "HRC" }, { name: "IT", departmentid: "IT" }, { name: "PA", departmentid: "PA" }, { name: "PROJECT ADMIN", departmentid: "PADMIN" }, { name: "PROJECTS", departmentid: "PROJ" }, { name: "PROPERTY", departmentid: "PROP" }, { name: "QS", departmentid: "QS" }, { name: "QS & CONTRACT MGT", departmentid: "QSCM" }, { name: "SAFETY & HEALTH", departmentid: "SH" }, { name: "TREASURY", departmentid: "TRS" }, ];

export const DEPARTMENT_STAFFS = [
{department: `PROPERTY`, staff: `RITCHDINI JUNIAN ANAK FREDDIE`},
{department: `QS`, staff: `CHAI YI THUNG, CARSON`},
{department: `PROJECTS`, staff: `FREDERICK CABUNGAN BANAWA`},
{department: `QS & CONTRACT MGT`, staff: `JONG SUK FANG`},
{department: `PROJECTS`, staff: `LENOR JOYCE SASOY LEGASPI-BANAWA`},
{department: `PROJECT ADMIN`, staff: `LIEW SZE YAH, NICOLE`},
{department: `QS & CONTRACT MGT`, staff: `NGO KEH TOH, ANNIE`},
{department: `PROJECTS`, staff: `OW WAN FOO, EDDIE`},
{department: `PROJECT ADMIN`, staff: `DORIS ANAK WILSON ELAH`},
{department: `PROJECTS`, staff: `HO AI CHIN`},
{department: `PROJECTS`, staff: `NORSAMSUDDIN ANAK BANGUN`},
{department: `PROJECTS`, staff: `SITI HAJAR BINTI MOHD YUSOP`},
{department: `PROPERTY`, staff: `ELLYZA EZLYN BINTI BLAISE`},
{department: `TREASURY`, staff: `JENNY YU PICK HAI`},
{department: `IT`, staff: `STEPHEN TAN SOON HONG`},
{department: `PROJECT ADMIN`, staff: `TAN KOK SAN, NICOLE`},
{department: `HR & CORPORATE COMM`, staff: `TANG LING PING, JENNIFER`},
{department: `ADMINISTRATION`, staff: `TAY CHIOK KEE`},
{department: `ACCOUNTS`, staff: `TIONG TECK YIENG`},
{department: `IT`, staff: `YONG SERN PIAT`},
{department: `CORPORATION`, staff: `AZALIZA BINTI AMIN`},
{department: `CORPORATION`, staff: `ELLY ANAK WILFRED`},
{department: `CORPORATION`, staff: `HELMI BIN PUTEH`},
{department: `CORPORATION`, staff: `MARCOS ANAK WARREN SAOH`},
{department: `CORPORATION`, staff: `NGUANG KIM KIONG`},
{department: `CORPORATION`, staff: `NORBAYU BT MUKU`},
{department: `CORPORATION`, staff: `SABREE BIN SABU`},
{department: `CORPORATION`, staff: `VERONICA A/P NOED`},
{department: `QS & CONTRACT MGT`, staff: `DIANA LEE MEI MEI`},
{department: `PROJECT ADMIN`, staff: `HASNIYATI HII BINTI ABDULLAH`},
{department: `PROJECT ADMIN`, staff: `KATHERINE YII JOU PEI`},
{department: `QS & CONTRACT MGT`, staff: `LAI CHEAU NEE`},
{department: `QS & CONTRACT MGT`, staff: `LIM WEI SING`},
{department: `QS & CONTRACT MGT`, staff: `SYLVIA TANG CHUNG TIEN`},
{department: `SAFETY & HEALTH`, staff: `ALAUDDIN BIN OTHMAN`},
{department: `SAFETY & HEALTH`, staff: `BONG ZHANG YING`},
{department: `SAFETY & HEALTH`, staff: `JULIAN ACHOI ANAK GANA`},
{department: `SAFETY & HEALTH`, staff: `MARVIN TARANG ANAK EDWARD`},
{department: `SAFETY & HEALTH`, staff: `NICHOLAS ANAK JANNIES`},
{department: `PROPERTY`, staff: `RICKFIELD GEWONG`},
{department: `SAFETY & HEALTH`, staff: `ROSLAN BIN ROSLI`},
{department: `SAFETY & HEALTH`, staff: `CAMILLA MARCIA KEDUAK ANAK UNYUK`},
{department: `PROPERTY`, staff: `CLINTON JAWA ANAK RICHARDLY`},
{department: `SAFETY & HEALTH`, staff: `COLIN MATHEW`},
{department: `PROPERTY`, staff: `GARY MADANG ANAK UNDOM`},
{department: `PROJECTS`, staff: `MAGDALYNE LIZA UBANG`},
{department: `SAFETY & HEALTH`, staff: `MOHAMAD HATTA BIN ROSIDI`},
{department: `SAFETY & HEALTH`, staff: `MUHAMMAD BIN SARIP`},
{department: `PROPERTY`, staff: `SUTIANA ANAK JESUT`},
{department: `CORPORATION`, staff: `LAU SIE CHUNG`},
{department: `CORPORATION`, staff: `TING SII KIONG`},
{department: `PROJECTS`, staff: `CHRIS BRYAN ANAK NAWOT`},
{department: `PROJECTS`, staff: `FRAVELLYN LYNDAI ANAK BUMA`},
{department: `PROJECTS`, staff: `CHIN CHEE HAO`},
{department: `PROJECT ADMIN`, staff: `LEE JIE LING`},
{department: `PROJECTS`, staff: `LIM KIAN BENG`},
{department: `PROJECTS`, staff: `MUHAMMAD ALFIAN WIRA SEPTIAN`},
{department: `PROJECTS`, staff: `MARDHIAH BINTI WAHID`},
{department: `PROJECTS`, staff: `CHUA SIAW TED`},
{department: `PROJECTS`, staff: `LESTINLEY LUIS ANAK LAWAI`},
{department: `PROJECT ADMIN`, staff: `SHIRLEY WONG LEE SAN`},
{department: `PA`, staff: `ANGELA WONG SIEW MEE`},
{department: `PA`, staff: `LORRAINE LIEW WOON FUNG`},
{department: `PA`, staff: `ELSIE LEE SUK CHER`},
{department: `PROJECT ADMIN`, staff: `EVELYN ANAK ANAU`},
{department: `PROJECTS`, staff: `HANNA SANTARINA ANAK MAURICE`},
{department: `PROJECTS`, staff: `KO LIAN CHUENG, KENNETH`},
{department: `PROJECT ADMIN`, staff: `LAI SIEW LIEN`},
{department: `PROJECTS`, staff: `MAC AUBREY ANAK MORIS @ MICHAEL`},
{department: `TREASURY`, staff: `JONG QIAO XUAN`},
{department: `TREASURY`, staff: `BONG JOO CHEE`},
{department: `TREASURY`, staff: `DAUD BIN MAHMOR`},
{department: `TREASURY`, staff: `LAW DUEN SIONG`},
{department: `TREASURY`, staff: `NANCY THU MEI SZE`},
{department: `TREASURY`, staff: `NG WAN LI, WENDY`},
{department: `TREASURY`, staff: `NUR ASFIA BIN MOHAMAD DOLLAH`},
{department: `TREASURY`, staff: `TAY GUAN PHING`},
{department: `TREASURY`, staff: `WEE GUEK YIAN`},
{department: `TREASURY`, staff: `WEI SZE NEI`},
{department: `TREASURY`, staff: `YUSUF BIN BAHARI`},
{department: `PROJECTS`, staff: `LEE PING CHIONG`},
{department: `PROJECT ADMIN`, staff: `MELISA ANAK SURING`},
{department: `PROJECTS`, staff: `MUHAMMAD AMIRUL RIDHZUAN STANNY`},
{department: `PROJECT ADMIN`, staff: `TING YING SIEW`},
{department: `CORPORATION`, staff: `DARREN JOSHUA LUNA ANAK MARVIN @ IMPI`},
{department: `QS & CONTRACT MGT`, staff: `ADEEBA ATHIRA BINTI BERAHIM`},
{department: `QS & CONTRACT MGT`, staff: `DESMOND LEE TONG HOWE`},
{department: `QS & CONTRACT MGT`, staff: `CALVIN GARAN ANAK GOHAN`},
{department: `PROJECTS`, staff: `LING NGIE LEE, KELVIN`},
{department: `PROJECTS`, staff: `SIM YUH SHIUN`},
{department: `PROPERTY`, staff: `CHRISTOPHER CHAI KOH WEE`},
{department: `PROPERTY`, staff: `VELDA CHANG CHIA YIN`},
{department: `PROJECTS`, staff: `ABDUL WARITH BIN MOHAMMAD PHILIP`},
{department: `PROJECTS`, staff: `ARCHIBAL CATIBOG MANANSALA`},
{department: `PROJECTS`, staff: `CHAI CHANG LECK, ERIC`},
{department: `PROJECTS`, staff: `CHIANG HENG HO`},
{department: `PROJECTS`, staff: `CHONG YU CHIAU`},
{department: `PROJECTS`, staff: `CHRIS HUDSON ANAK BUJANG`},
{department: `PROJECTS`, staff: `KELVIN CHAI HOCK JOI`},
{department: `PROJECTS`, staff: `LEE KUET LUNG`},
{department: `PROJECTS`, staff: `LIM KAI HENG`},
{department: `PROJECTS`, staff: `SELINBIT ANAK MOS`},
{department: `PROJECTS`, staff: `TOH JAG HUI`},
{department: `PROJECTS`, staff: `TULIS ANAK CHANDANG`},
{department: `PROJECTS`, staff: `VIVIANA ONG ZHI JINN`},
{department: `PROJECTS`, staff: `LIEW HOCK RUI`},
{department: `PROJECTS`, staff: `TIBU ANAK DAUD`},
{department: `QS & CONTRACT MGT`, staff: `ALVIN CHONG TZE HUI`},
{department: `QS & CONTRACT MGT`, staff: `CHAN HOOD SOO`},
{department: `PROJECTS`, staff: `CHIN YIAN CHON, ALSON`},
{department: `ADMINISTRATION`, staff: `CHINDAI ANAK JOSEPH`},
{department: `PA`, staff: `HENG MUI KEE`},
{department: `PROJECTS`, staff: `HON JUN KHIONG`},
{department: `PROJECTS`, staff: `JIMENO JR. LUGUE JERUSALEM`},
{department: `QS & CONTRACT MGT`, staff: `JONG SIAW FOONG, STEVEN`},
{department: `PROJECTS`, staff: `KELVIN KANG KIAN LAI`},
{department: `PROJECTS`, staff: `KELVIN YII SENG HUA`},
{department: `PROJECTS`, staff: `LAU YUK SIONG, PHILIP`},
{department: `PROJECTS`, staff: `SIAW WEN YIAP, MICHEAL`},
{department: `PROJECTS`, staff: `SIM KAY CHIAN, STEPHEN`},
{department: `PROJECTS`, staff: `TING SING HWA`},
{department: `PROJECTS`, staff: `JULIAN LAU KHERR LOONG`},
{department: `PROJECT ADMIN`, staff: `LAU KIEW HING`},
{department: `PROJECTS`, staff: `SIEW MING HUA`},
{department: `PROJECTS`, staff: `SIM YIK CHWIN`},
{department: `PROJECTS`, staff: `ANDYANNA ANAK ADRIS`},
{department: `PROPERTY`, staff: `JASCICA ANAK BAJAK`},
{department: `PROJECTS`, staff: `BOBIC IZACK ANAK RAJINOK`},
{department: `ACCOUNTS`, staff: `CYNTHIA TANG JOCK YUN`},
{department: `ACCOUNTS`, staff: `MICHELLE HON XUE YUN`},
{department: `ACCOUNTS`, staff: `VANESSA TING MEE JIUN`},
{department: `ACCOUNTS`, staff: `VIONNIE CHIEW SIEW LING`},
{department: `CORPORATION`, staff: `VOON LIK YONG`},
{department: `ACCOUNTS`, staff: `WENDY CHONG LEE YA`},
{department: `ACCOUNTS`, staff: `YAP LI LI`},
{department: `ADMINISTRATION`, staff: `YASMINE FATHIAH BINTI MOHD DEXTER HOWELL`},
{department: `ACCOUNTS`, staff: `BELINDA TAN CHAI YING`},
{department: `CORPORATION`, staff: `BILLY JONG HUNG ENG`},
{department: `CORPORATION`, staff: `CHONG UU LEONG, ZACK`},
{department: `PROJECT ADMIN`, staff: `EMILY ANAK USAM`},
{department: `ACCOUNTS`, staff: `HELY ANAK SOTIN`},
{department: `CORPORATION`, staff: `JOEL SU TAI TUNG`},
{department: `ACCOUNTS`, staff: `JOSEPHINE FOO SIEW PHENG`},
{department: `CORPORATION`, staff: `LIM SOO HUI`},
{department: `CORPORATION`, staff: `LING SHI HING, ERIC`},
{department: `CORPORATION`, staff: `MARIA JATTI ANAK ENA`},
{department: `CORPORATION`, staff: `MARIA SU`},
{department: `ADMINISTRATION`, staff: `OLIZARENA ANAK ENA`},
{department: `ACCOUNTS`, staff: `THON HUI HUI`},
{department: `ACCOUNTS`, staff: `TIONG SIEW LING`},
{department: `CORPORATION`, staff: `VOON SAY NYUK, SHIRLEY`},
{department: `ADMINISTRATION`, staff: `WAN MOHAMAD BIN WAN ALLI`},
{department: `PROPERTY`, staff: `BONG MEI LUN`},
{department: `PROJECTS`, staff: `IDZWAN HAKIMI BIN TAHIR`},
{department: `PROPERTY`, staff: `CHIENG CHING KUOK`},
{department: `PROJECTS`, staff: `CHIENG SHAW YAW`},
{department: `PROPERTY`, staff: `CHONG CHIA WEI`},
{department: `PROJECTS`, staff: `DAVIDSON AK DAYUT`},
{department: `PROJECTS`, staff: `FLONY MEREH ANAK DAVID`},
{department: `PROJECTS`, staff: `GOH CHIN SING`},
{department: `PROJECT ADMIN`, staff: `JACKLYN ANAK JUGAH`},
{department: `PROJECTS`, staff: `PERNANDEZ TULIS`},
{department: `PROJECTS`, staff: `SYLVESTER MIKE LIEW CHO KEAT`},
{department: `PROJECTS`, staff: `TANG SING HUI`},
{department: `PROPERTY`, staff: `TEO TAI WEE, STEPHEN`},
{department: `PROJECTS`, staff: `ARIF BIN CHIK`},
{department: `PROJECTS`, staff: `MOHAMMAD AZEIR BIN UMIN`},
{department: `PROJECTS`, staff: `RUSWAN ASWARI BIN YAHYA`},
{department: `PROJECTS`, staff: `PRESCILLIA ANAK PHILIP`},
{department: `PROPERTY`, staff: `FIODA LEW SHIN YII`},
{department: `PROJECT ADMIN`, staff: `CHRISTIANA ROMINA ANAK JANIS`},
{department: `PROJECT ADMIN`, staff: `DAYANG NUR AININA BINTI ABG MOHAMAD`},
{department: `PROJECT ADMIN`, staff: `FADILLAH BTE ABDULLAH`},
{department: `PROJECT ADMIN`, staff: `HII CHUI YEN, IVY`},
{department: `PROJECT ADMIN`, staff: `MONA KEDAYA ANAK STORY`},
{department: `PROJECT ADMIN`, staff: `NAJA ANAK NYAUN`},
{department: `PROJECT ADMIN`, staff: `SANDRA ANAK JAWING`},
{department: `PROJECT ADMIN`, staff: `SONIA VIVIANI ANAK JANIS`},
{department: `PROJECT ADMIN`, staff: `TING SIAW WEE`},
{department: `PROJECT ADMIN`, staff: `VOON KHENG HUA, VALERIE`},
{department: `HR `, staff: `AMINAH BINTI ABIDIN`},
{department: `HR`, staff: `CHAI JIEW LEONG`},
{department: `HR `, staff: `ADRIAN CHAI YOU QING`},
{department: `HR `, staff: `HO SIAW LEE, LILY`},
{department: `HR `, staff: `IRENE KHO AI LING`},
{department: `HR `, staff: `IRWAN BIN BUJANG`},
{department: `HR `, staff: `JOYCE LIM FAYE`},
{department: `HR `, staff: `TANG KUI SIEW, DEBBY`},
{department: `PROPERTY`, staff: `ANDRESS LANTUK ANAK MAJING`},
{department: `PROPERTY`, staff: `WINNIE LAI EE FEI`},
{department: `BPL`, staff: `HII YII SHIN`},
{department: `ADMINISTRATION`, staff: `ABDUL AZIZ BIN HIPENI`},
{department: `ADMINISTRATION`, staff: `ALYSSA ASONG SIMON`},
{department: `ADMINISTRATION`, staff: `LINDA ANAK BUYONG`},
{department: `ADMINISTRATION`, staff: `VICTORIA ANAK UMPANG`},
{department: `PROPERTY`, staff: `AARON AU SAU SIANG`},
{department: `PROPERTY`, staff: `ALEXANDER LAI HORNG WEN`},
{department: `PROPERTY`, staff: `ANGIE JOAN ANAK DANIEL`},
{department: `SAFETY & HEALTH`, staff: `CHARLES LEE WEE TECK`},
{department: `ADMINISTRATION`, staff: `CHARLES REYNOLD ANAK NIGEL`},
{department: `PROPERTY`, staff: `CHONG SIAW HUA`},
{department: `PROPERTY`, staff: `FARAHANI BINTI HAINI`},
{department: `ADMINISTRATION`, staff: `LAI SIAW LING`},
{department: `BPL`, staff: `LESLIE LIM CHUNG LEONG`},
{department: `QS & CONTRACT MGT`, staff: `LING SHEAU WEI`},
{department: `ADMINISTRATION`, staff: `NGO JIN JIN`},
{department: `PROPERTY`, staff: `PHANG MING JING, RAINIE`},
{department: `PROPERTY`, staff: `SHARON NG KHE SWYN`},
{department: `ADMINISTRATION`, staff: `TAN YIEN LIN`},
{department: `ADMINISTRATION`, staff: `THIAN FUI CHIUN, KERRY`},
{department: `ADMINISTRATION`, staff: `TIE SHIE LING`},
{department: `PROPERTY`, staff: `TIEO SEOW LING, LYN`},
{department: `ADMINISTRATION`, staff: `TING KWAN HEE`},
{department: `ADMINISTRATION`, staff: `YEO TANG TANG`},
{department: `ADMINISTRATION`, staff: `ALBINUS PETRUS RATIM NGIBAN`},
{department: `ADMINISTRATION`, staff: `ALI BIN SABRI`},
{department: `ADMINISTRATION`, staff: `BONNIE ANAK ANTHONY`},
{department: `ADMINISTRATION`, staff: `HAIDI BIN MARANI`},
{department: `ADMINISTRATION`, staff: `TUNI ANAK OUI JUAN`},
{department: `PROJECTS`, staff: `JOHAN ANAK JAWA`},
{department: `ACCOUNTS`, staff: `CHOO ZONGWEI`},
{department: `PROPERTY`, staff: `CHUA YONG TIEN, EUNICE`},
{department: `ACCOUNTS`, staff: `CINDY CHONG LEE MING`},
{department: `ACCOUNTS`, staff: `JONG HUI WOON`},
{department: `ACCOUNTS`, staff: `LAU LI KUO`},
{department: `ACCOUNTS`, staff: `MICHELLE WONG XIU HAN`},
{department: `ACCOUNTS`, staff: `NG KHOON CHIENG`},
{department: `ACCOUNTS`, staff: `SOH MEI XING`},
{department: `ACCOUNTS`, staff: `TAN KAH HO, LEON`},
{department: `ACCOUNTS`, staff: `VANESSA TAY MING FONG`},
{department: `ACCOUNTS`, staff: `JOYCE TEH YEE`},
{department: `ACCOUNTS`, staff: `TERRY THAM TZE PING`},
{department: `PROPERTY`, staff: `TAY YI YING`},
{department: `ACCOUNTS`, staff: `JACKUELINE ONG YUEN CHING`},
{department: `ACCOUNTS`, staff: `ONG CHIAW SIAN`},
{department: `ACCOUNTS`, staff: `ANNIE LEE SIEW PHIN`},
{department: `ACCOUNTS`, staff: `CHAI LI SWAN`},
{department: `ACCOUNTS`, staff: `CHAI PEI SHAN`},
{department: `ACCOUNTS`, staff: `CHAI SIN HWEI`},
{department: `ACCOUNTS`, staff: `CHIN JIUN HUAH, ANGEL`},
{department: `ACCOUNTS`, staff: `CHRISTABELLA DUIE ANAK CHRISTOPHER NYENGGANG`},
{department: `ACCOUNTS`, staff: `JANICE ANG CI XIA`},
{department: `ACCOUNTS`, staff: `JI CHOU KING`},
{department: `ACCOUNTS`, staff: `KHO BOON POH`},
{department: `ACCOUNTS`, staff: `LIM EK HUA`},
{department: `ACCOUNTS`, staff: `ONG CHIEW LING`},
{department: `ACCOUNTS`, staff: `SIA SOON GUEI`},
{department: `ACCOUNTS`, staff: `SIM PEI CHUN`},
{department: `ACCOUNTS`, staff: `SIM SIAT FUNG, ALICE`},
{department: `ACCOUNTS`, staff: `TAN MIAW ENG, ANGELINE`},
{department: `ACCOUNTS`, staff: `WONG WOAN MIING, RACHELLE`},
{department: `ACCOUNTS`, staff: `YONG TING`},
{department: `CORPORATION`, staff: `VOON JIEW MIN`},
{department: `CORPORATION`, staff: `BONG IT FIAN, IVAN`},
{department: `CORPORATION`, staff: `CHEE SIAW PAW`},
{department: `CORPORATION`, staff: `KHO HO SIA, GEORGE`},
{department: `CORPORATION`, staff: `WONG MING`},
{department: `CORPORATION`, staff: `MOHD SHAHRUL SHAH FENDI HENDY DVAI`},
{department: `CORPORATION`, staff: `REMY ANAK JOHEL`},
{department: `CORPORATION`, staff: `FABIANA ANAK CHAN`},
{department: `CORPORATION`, staff: `LIEGAN ANAK MANGGUH`},
{department: `CORPORATION`, staff: `NOOR MARLIDAH HAI`},
{department: `CORPORATION`, staff: `BRIGETTE BRENDA BASE`},
{department: `CORPORATION`, staff: `CHENDANG ANAK THOMAS ALI`},
{department: `CORPORATION`, staff: `CHIN LEE HUA`},
{department: `CORPORATION`, staff: `DIANA BIDAI ANAK MENDALI`},
{department: `CORPORATION`, staff: `JOHNNY HO KOK SIAM`},
{department: `CORPORATION`, staff: `JONG KIM WONG`},
{department: `CORPORATION`, staff: `JULLYANA GORILA ANAK JENOS`},
{department: `CORPORATION`, staff: `LESTER LUNA ANAK ULOK`},
{department: `CORPORATION`, staff: `MAINA NICKOLA ANAK MICHILE`},
{department: `CORPORATION`, staff: `NELVIN BRIAN ANAK NAWOT`},
{department: `CORPORATION`, staff: `NURUL HURAIRAH BINTI SARIP`},
{department: `CORPORATION`, staff: `SYLVESTER ANAK KENETH KANYAN`},
{department: `CORPORATION`, staff: `VERONICA SULAN ANAK VINCENT`},
{department: `CORPORATION`, staff: `VORNICA NAYAN ANAK NANANG`},
{department: `ADMINISTRATION`, staff: `EDWARD TENLEY AK FRANCIS KETIR`},
{department: `ADMINISTRATION`, staff: `YUNG MEI HUA, MANDY`},
{department: `IT`, staff: `GASTON QION EMMANUEL AK GEORGE`},
{department: `IT`, staff: `LO JAK FATT, EVENCE`},
{department: `IT`, staff: `TAN KEENG LING`},
{department: `IT`, staff: `YONG WEI TING`},
{department: `PROPERTY`, staff: `ABRAHAM CHUANG-CHYI TIONG`},
{department: `PROPERTY`, staff: `KATHERINE SONG`},
{department: `PROPERTY`, staff: `SYLVIA ANAK CHAONG`},
{department: `PROPERTY`, staff: `YVONNE SHARON ANAK MIKOLDEN`},
];

export const STAFFS = [
  {fullname: `RITCHDINI JUNIAN ANAK FREDDIE`, position: `Social Media Assistant`, job_grade: `E1`, date_joined: ``},
{fullname: `CHAI YI THUNG, CARSON`, position: `Senior QS`, job_grade: `E2`, date_joined: ``},
{fullname: `FREDERICK CABUNGAN BANAWA`, position: `Project Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `JONG SUK FANG`, position: `Senior QS`, job_grade: `E3`, date_joined: ``},
{fullname: `LENOR JOYCE SASOY LEGASPI-BANAWA`, position: `Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `LIEW SZE YAH, NICOLE`, position: `Admin Assistant - Projects`, job_grade: `NE2`, date_joined: ``},
{fullname: `NGO KEH TOH, ANNIE`, position: `Assistant Manager - Contracts`, job_grade: `E3`, date_joined: ``},
{fullname: `OW WAN FOO, EDDIE`, position: `Electrical Engineer`, job_grade: `NES5`, date_joined: ``},
{fullname: `DORIS ANAK WILSON ELAH`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `HO AI CHIN`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `NORSAMSUDDIN ANAK BANGUN`, position: `Surveyor cum Supervisor`, job_grade: `NES5`, date_joined: ``},
{fullname: `SITI HAJAR BINTI MOHD YUSOP`, position: `Project Engineer `, job_grade: `E2`, date_joined: ``},
{fullname: `ELLYZA EZLYN BINTI BLAISE`, position: `Gallery Administrator`, job_grade: `E1`, date_joined: ``},
{fullname: `JENNY YU PICK HAI`, position: `Senior Manager - Treasury`, job_grade: `SM1`, date_joined: ``},
{fullname: `STEPHEN TAN SOON HONG`, position: `Manager - Network Admin`, job_grade: `M1`, date_joined: ``},
{fullname: `TAN KOK SAN, NICOLE`, position: `Senior Officer - Project Admin cum Assistant QMR`, job_grade: `E2`, date_joined: ``},
{fullname: `TANG LING PING, JENNIFER`, position: `Senior Manager - HR & Corp Comm`, job_grade: `SM1`, date_joined: ``},
{fullname: `TAY CHIOK KEE`, position: `Senior Manager - Procurement & Admin`, job_grade: `SM2`, date_joined: ``},
{fullname: `TIONG TECK YIENG`, position: `Assistant General Manager - Finance`, job_grade: `SM2`, date_joined: ``},
{fullname: `YONG SERN PIAT`, position: `IT Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `AZALIZA BINTI AMIN`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `ELLY ANAK WILFRED`, position: `Admin Assistant`, job_grade: `NE2`, date_joined: ``},
{fullname: `HELMI BIN PUTEH`, position: `Plant Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `MARCOS ANAK WARREN SAOH`, position: `Assistant Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `NGUANG KIM KIONG`, position: `Supervisor`, job_grade: `NES5`, date_joined: ``},
{fullname: `NORBAYU BT MUKU`, position: `QAQC Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `SABREE BIN SABU`, position: `QA Technician`, job_grade: `NE2`, date_joined: ``},
{fullname: `VERONICA A/P NOED`, position: `Admin Assistant`, job_grade: `NE3`, date_joined: ``},
{fullname: `DIANA LEE MEI MEI`, position: `Senior QS`, job_grade: `E3`, date_joined: ``},
{fullname: `HASNIYATI HII BINTI ABDULLAH`, position: `Admin Assistant - Projects`, job_grade: `NE3`, date_joined: ``},
{fullname: `KATHERINE YII JOU PEI`, position: `Admin Assistant - Projects`, job_grade: `NE2`, date_joined: ``},
{fullname: `LAI CHEAU NEE`, position: `Senor QS`, job_grade: `E2`, date_joined: ``},
{fullname: `LIM WEI SING`, position: `Senior QS`, job_grade: `E2`, date_joined: ``},
{fullname: `SYLVIA TANG CHUNG TIEN`, position: `QS`, job_grade: `E1`, date_joined: ``},
{fullname: `ALAUDDIN BIN OTHMAN`, position: `Officer - Safety & Health`, job_grade: `NES6`, date_joined: ``},
{fullname: `BONG ZHANG YING`, position: `Site Safety Supervisor`, job_grade: `E1`, date_joined: ``},
{fullname: `JULIAN ACHOI ANAK GANA`, position: `Site Safety Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `MARVIN TARANG ANAK EDWARD`, position: `Officer - Safety & Health `, job_grade: `E3`, date_joined: ``},
{fullname: `NICHOLAS ANAK JANNIES`, position: `Officer - Safety & Health`, job_grade: `NES6`, date_joined: ``},
{fullname: `RICKFIELD GEWONG`, position: `Officer - Technical`, job_grade: `NES4`, date_joined: ``},
{fullname: `ROSLAN BIN ROSLI`, position: `Site Safety Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `CAMILLA MARCIA KEDUAK ANAK UNYUK`, position: `Site Safety Supervisor `, job_grade: `NES4`, date_joined: ``},
{fullname: `CLINTON JAWA ANAK RICHARDLY`, position: `Senior Officer - Building Operations`, job_grade: `E2`, date_joined: ``},
{fullname: `COLIN MATHEW`, position: `Officer - Safety & Health`, job_grade: `NES6`, date_joined: ``},
{fullname: `GARY MADANG ANAK UNDOM`, position: `Technician - Maintenance`, job_grade: `NES4`, date_joined: ``},
{fullname: `MAGDALYNE LIZA UBANG`, position: `Environmental Officer`, job_grade: `E1`, date_joined: ``},
{fullname: `MOHAMAD HATTA BIN ROSIDI`, position: `Site Safety Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `MUHAMMAD BIN SARIP`, position: `Site Safety Supervisor `, job_grade: `NES4`, date_joined: ``},
{fullname: `SUTIANA ANAK JESUT`, position: `Officer - Leasing Admin`, job_grade: `E1`, date_joined: ``},
{fullname: `LAU SIE CHUNG`, position: `Mechanic`, job_grade: `NES4`, date_joined: ``},
{fullname: `TING SII KIONG`, position: `Store Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `CHRIS BRYAN ANAK NAWOT`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `FRAVELLYN LYNDAI ANAK BUMA`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `CHIN CHEE HAO`, position: `Site Coordinator`, job_grade: `NES6`, date_joined: ``},
{fullname: `LEE JIE LING`, position: `Admin Assistant `, job_grade: `NES4`, date_joined: ``},
{fullname: `LIM KIAN BENG`, position: `Site Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `MUHAMMAD ALFIAN WIRA SEPTIAN`, position: `Assistant Project Manager`, job_grade: `E3`, date_joined: ``},
{fullname: `MARDHIAH BINTI WAHID`, position: `Technical Assistant`, job_grade: `E1`, date_joined: ``},
{fullname: `CHUA SIAW TED`, position: `Site Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `LESTINLEY LUIS ANAK LAWAI`, position: `Surveyor`, job_grade: `NES5`, date_joined: ``},
{fullname: `SHIRLEY WONG LEE SAN`, position: `Admin Assistant - Project`, job_grade: `E1`, date_joined: ``},
{fullname: `ANGELA WONG SIEW MEE`, position: `Officer - PA`, job_grade: `E1`, date_joined: ``},
{fullname: `LORRAINE LIEW WOON FUNG`, position: `Officer - PA`, job_grade: `E2`, date_joined: ``},
{fullname: `ELSIE LEE SUK CHER`, position: `Officer - PA`, job_grade: `NES4`, date_joined: ``},
{fullname: `EVELYN ANAK ANAU`, position: `Cleaner cum Tea Lady`, job_grade: `NE1`, date_joined: ``},
{fullname: `HANNA SANTARINA ANAK MAURICE`, position: `Admin Assistant - Project`, job_grade: `NE2`, date_joined: ``},
{fullname: `KO LIAN CHUENG, KENNETH`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `LAI SIEW LIEN`, position: `Officer-Projects Admin (Jasa)`, job_grade: `E1`, date_joined: ``},
{fullname: `MAC AUBREY ANAK MORIS @ MICHAEL`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `JONG QIAO XUAN`, position: `Clerk - Treasury`, job_grade: `NES4`, date_joined: ``},
{fullname: `BONG JOO CHEE`, position: `Senior Officer - Treasury`, job_grade: `NES5`, date_joined: ``},
{fullname: `DAUD BIN MAHMOR`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `LAW DUEN SIONG`, position: `Senior Clerk - Treasury`, job_grade: `NE3`, date_joined: ``},
{fullname: `NANCY THU MEI SZE`, position: `Senior Clerk - Treasury`, job_grade: `NE3`, date_joined: ``},
{fullname: `NG WAN LI, WENDY`, position: `Senior Clerk - Treasury`, job_grade: `NE3`, date_joined: ``},
{fullname: `NUR ASFIA BIN MOHAMAD DOLLAH`, position: `Senior Office Assistant`, job_grade: `NE2`, date_joined: ``},
{fullname: `TAY GUAN PHING`, position: `Clerk - Treasury`, job_grade: `NE3`, date_joined: ``},
{fullname: `WEE GUEK YIAN`, position: `Assistant Manager - Treasury`, job_grade: `NES6`, date_joined: ``},
{fullname: `WEI SZE NEI`, position: `Assistant Manager - Treasury`, job_grade: `E3`, date_joined: ``},
{fullname: `YUSUF BIN BAHARI`, position: `Office Assistant `, job_grade: `NE1`, date_joined: ``},
{fullname: `LEE PING CHIONG`, position: `Construction Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `MELISA ANAK SURING`, position: `Site Clerk`, job_grade: `NE1`, date_joined: ``},
{fullname: `MUHAMMAD AMIRUL RIDHZUAN STANNY`, position: `Project Engineer`, job_grade: `NES5`, date_joined: ``},
{fullname: `TING YING SIEW`, position: `Admin Assistant - Project`, job_grade: `NE2`, date_joined: ``},
{fullname: `DARREN JOSHUA LUNA ANAK MARVIN @ IMPI`, position: `Asst Officer - Safety & Health`, job_grade: `NES4`, date_joined: ``},
{fullname: `ADEEBA ATHIRA BINTI BERAHIM`, position: `QS`, job_grade: `E1`, date_joined: ``},
{fullname: `DESMOND LEE TONG HOWE`, position: `QS`, job_grade: `E1`, date_joined: ``},
{fullname: `CALVIN GARAN ANAK GOHAN`, position: `Assistant QS`, job_grade: `NES4`, date_joined: ``},
{fullname: `LING NGIE LEE, KELVIN`, position: `Resident Engineer`, job_grade: `E3`, date_joined: ``},
{fullname: `SIM YUH SHIUN`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `CHRISTOPHER CHAI KOH WEE`, position: `Graphic Designer`, job_grade: `E1`, date_joined: ``},
{fullname: `VELDA CHANG CHIA YIN`, position: `Senior Graphic Designer`, job_grade: `E2`, date_joined: ``},
{fullname: `ABDUL WARITH BIN MOHAMMAD PHILIP`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `ARCHIBAL CATIBOG MANANSALA`, position: `Project Manager `, job_grade: `M2`, date_joined: ``},
{fullname: `CHAI CHANG LECK, ERIC`, position: `Assistant Project Manager`, job_grade: `NES6`, date_joined: ``},
{fullname: `CHIANG HENG HO`, position: `Officer - Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `CHONG YU CHIAU`, position: `Site Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `CHRIS HUDSON ANAK BUJANG`, position: `Draughtsman`, job_grade: `NES4`, date_joined: ``},
{fullname: `KELVIN CHAI HOCK JOI`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `LEE KUET LUNG`, position: `Senior Projects Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `LIM KAI HENG`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `SELINBIT ANAK MOS`, position: `Surveyor`, job_grade: `NES6`, date_joined: ``},
{fullname: `TOH JAG HUI`, position: `M & E Coordinator`, job_grade: `NES5`, date_joined: ``},
{fullname: `TULIS ANAK CHANDANG`, position: `Surveyor`, job_grade: `NES5`, date_joined: ``},
{fullname: `VIVIANA ONG ZHI JINN`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `LIEW HOCK RUI`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `TIBU ANAK DAUD`, position: `Surveyor`, job_grade: `NES5`, date_joined: ``},
{fullname: `ALVIN CHONG TZE HUI`, position: `Senior Contracts Manager`, job_grade: `SM1`, date_joined: ``},
{fullname: `CHAN HOOD SOO`, position: `Contracts Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `CHIN YIAN CHON, ALSON`, position: `Senior Project Manager`, job_grade: `SM1`, date_joined: ``},
{fullname: `CHINDAI ANAK JOSEPH`, position: `Driver - Simon Lau`, job_grade: `NE2`, date_joined: ``},
{fullname: `HENG MUI KEE`, position: `Manager- Office Admin & Head of PA`, job_grade: `M1`, date_joined: ``},
{fullname: `HON JUN KHIONG`, position: `Project Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `JIMENO JR. LUGUE JERUSALEM`, position: `Senior Project Manager`, job_grade: `SM2`, date_joined: ``},
{fullname: `JONG SIAW FOONG, STEVEN`, position: `Contracts Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `KELVIN KANG KIAN LAI`, position: `Senior Project Manager`, job_grade: `SM2`, date_joined: ``},
{fullname: `KELVIN YII SENG HUA`, position: `Assistant Project Manager`, job_grade: `E3`, date_joined: ``},
{fullname: `LAU YUK SIONG, PHILIP`, position: `General Manager - Projects`, job_grade: `GM1`, date_joined: ``},
{fullname: `SIAW WEN YIAP, MICHEAL`, position: `Senior Project Manager`, job_grade: `SM1`, date_joined: ``},
{fullname: `SIM KAY CHIAN, STEPHEN`, position: `Lab Supervisor`, job_grade: `NES5`, date_joined: ``},
{fullname: `TING SING HWA`, position: `Project Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `JULIAN LAU KHERR LOONG`, position: `Project Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `LAU KIEW HING`, position: `Officer - Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `SIEW MING HUA`, position: `Project Manager`, job_grade: `M2`, date_joined: ``},
{fullname: `SIM YIK CHWIN`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `ANDYANNA ANAK ADRIS`, position: `Draughtsman`, job_grade: `NES4`, date_joined: ``},
{fullname: `JASCICA ANAK BAJAK`, position: `Customer Service Executive`, job_grade: `NES4`, date_joined: ``},
{fullname: `BOBIC IZACK ANAK RAJINOK`, position: `Clerk Of Works`, job_grade: `NES5`, date_joined: ``},
{fullname: `CYNTHIA TANG JOCK YUN`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `MICHELLE HON XUE YUN`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `VANESSA TING MEE JIUN`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `VIONNIE CHIEW SIEW LING`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `VOON LIK YONG`, position: `Assistant Manager - Quarry Operations`, job_grade: `NES6`, date_joined: ``},
{fullname: `WENDY CHONG LEE YA`, position: `Senior Officer - Accounts`, job_grade: `NES5`, date_joined: ``},
{fullname: `YAP LI LI`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `YASMINE FATHIAH BINTI MOHD DEXTER HOWELL`, position: `Executive - Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `BELINDA TAN CHAI YING`, position: `Senior Clerk - Accounts`, job_grade: `NE3`, date_joined: ``},
{fullname: `BILLY JONG HUNG ENG`, position: `Sales & Admin Coordinator`, job_grade: `NES4`, date_joined: ``},
{fullname: `CHONG UU LEONG, ZACK`, position: `Senior Sales & Marketing Executive`, job_grade: `NES5`, date_joined: ``},
{fullname: `EMILY ANAK USAM`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `HELY ANAK SOTIN`, position: `Senior Clerk - Accounts`, job_grade: `NE3`, date_joined: ``},
{fullname: `JOEL SU TAI TUNG`, position: `Manager - Quality, Safety, Health & Environmental`, job_grade: `M1`, date_joined: ``},
{fullname: `JOSEPHINE FOO SIEW PHENG`, position: `Assistant Accountant`, job_grade: `E3`, date_joined: ``},
{fullname: `LIM SOO HUI`, position: `Office Assistant`, job_grade: `NE3`, date_joined: ``},
{fullname: `LING SHI HING, ERIC`, position: `Site Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `MARIA JATTI ANAK ENA`, position: `Admin Assistant / PA`, job_grade: `NES4`, date_joined: ``},
{fullname: `MARIA SU`, position: `Admin Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `OLIZARENA ANAK ENA`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `THON HUI HUI`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `TIONG SIEW LING`, position: `Assistant Accountant`, job_grade: `E3`, date_joined: ``},
{fullname: `VOON SAY NYUK, SHIRLEY`, position: `Senior Sales & Marketing Executive`, job_grade: `NES5`, date_joined: ``},
{fullname: `WAN MOHAMAD BIN WAN ALLI`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `BONG MEI LUN`, position: `Project Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `IDZWAN HAKIMI BIN TAHIR`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `CHIENG CHING KUOK`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `CHIENG SHAW YAW`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `CHONG CHIA WEI`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `DAVIDSON AK DAYUT`, position: `Surveyor`, job_grade: `NES5`, date_joined: ``},
{fullname: `FLONY MEREH ANAK DAVID`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `GOH CHIN SING`, position: `Construction Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `JACKLYN ANAK JUGAH`, position: `Admin Assistant - Project`, job_grade: `E1`, date_joined: ``},
{fullname: `PERNANDEZ TULIS`, position: `M & E Engineer`, job_grade: `NES4`, date_joined: ``},
{fullname: `SYLVESTER MIKE LIEW CHO KEAT`, position: `Senior Project Engineer`, job_grade: `E2`, date_joined: ``},
{fullname: `TANG SING HUI`, position: `Site Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `TEO TAI WEE, STEPHEN`, position: `Site Supervisor`, job_grade: `NES5`, date_joined: ``},
{fullname: `ARIF BIN CHIK`, position: `Site Coordinator`, job_grade: `NES4`, date_joined: ``},
{fullname: `MOHAMMAD AZEIR BIN UMIN`, position: `Surveyor`, job_grade: `NES5`, date_joined: ``},
{fullname: `RUSWAN ASWARI BIN YAHYA`, position: `Project Engineer`, job_grade: `E1`, date_joined: ``},
{fullname: `PRESCILLIA ANAK PHILIP`, position: `Assistant Project Planner`, job_grade: `E1`, date_joined: ``},
{fullname: `FIODA LEW SHIN YII`, position: `Assistant to Director`, job_grade: `NES4`, date_joined: ``},
{fullname: `CHRISTIANA ROMINA ANAK JANIS`, position: `Admin Asst - Project Admin`, job_grade: `NE2`, date_joined: ``},
{fullname: `DAYANG NUR AININA BINTI ABG MOHAMAD`, position: `Admin Assistant - Projects`, job_grade: `NE2`, date_joined: ``},
{fullname: `FADILLAH BTE ABDULLAH`, position: `Admin Assistant - Projects`, job_grade: `NE2`, date_joined: ``},
{fullname: `HII CHUI YEN, IVY`, position: `Admin Assistant - Projects`, job_grade: `NE3`, date_joined: ``},
{fullname: `MONA KEDAYA ANAK STORY`, position: `Admin Assistant - Projects`, job_grade: `NE2`, date_joined: ``},
{fullname: `NAJA ANAK NYAUN`, position: `Officer - Project Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `SANDRA ANAK JAWING`, position: `Officer - Project Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `SONIA VIVIANI ANAK JANIS`, position: `Admin Assistant - Projects`, job_grade: `NE2`, date_joined: ``},
{fullname: `TING SIAW WEE`, position: `Officer - Project Admin`, job_grade: `E1`, date_joined: ``},
{fullname: `VOON KHENG HUA, VALERIE`, position: `Officer - Project Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `AMINAH BINTI ABIDIN`, position: `Officer - HR`, job_grade: `E1`, date_joined: ``},
{fullname: `CHAI JIEW LEONG`, position: `Officer - HR`, job_grade: `E1`, date_joined: ``},
{fullname: `ADRIAN CHAI YOU QING`, position: `Officer - HR`, job_grade: `E1`, date_joined: ``},
{fullname: `HO SIAW LEE, LILY`, position: `Officer - HR`, job_grade: `NES4`, date_joined: ``},
{fullname: `IRENE KHO AI LING`, position: `Assistant Manager - HR`, job_grade: `E3`, date_joined: ``},
{fullname: `IRWAN BIN BUJANG`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `JOYCE LIM FAYE`, position: `HR Assistant`, job_grade: `NE2`, date_joined: ``},
{fullname: `TANG KUI SIEW, DEBBY`, position: `Assistant Manager - HR`, job_grade: `E3`, date_joined: ``},
{fullname: `ANDRESS LANTUK ANAK MAJING`, position: `Admin Officer - Property Development`, job_grade: `E1`, date_joined: ``},
{fullname: `WINNIE LAI EE FEI`, position: `Officer - Property Development`, job_grade: `E1`, date_joined: ``},
{fullname: `HII YII SHIN`, position: `Assistant Site Manager`, job_grade: `E3`, date_joined: ``},
{fullname: `ABDUL AZIZ BIN HIPENI`, position: `Officer - General Coordinator`, job_grade: `NES4`, date_joined: ``},
{fullname: `ALYSSA ASONG SIMON`, position: `Admin Assistant`, job_grade: `NE2`, date_joined: ``},
{fullname: `LINDA ANAK BUYONG`, position: `Clerk - Admin`, job_grade: `NE2`, date_joined: ``},
{fullname: `VICTORIA ANAK UMPANG`, position: `Officer - Reception`, job_grade: `NES4`, date_joined: ``},
{fullname: `AARON AU SAU SIANG`, position: `Property Development Executive`, job_grade: `NES5`, date_joined: ``},
{fullname: `ALEXANDER LAI HORNG WEN`, position: `Assistant Manager - Property Development`, job_grade: `NES6`, date_joined: ``},
{fullname: `ANGIE JOAN ANAK DANIEL`, position: `Asst Manager - Sales & Marketing`, job_grade: `NES5`, date_joined: ``},
{fullname: `CHARLES LEE WEE TECK`, position: `Manager - Safety, Security, Health & Environment`, job_grade: `M1`, date_joined: ``},
{fullname: `CHARLES REYNOLD ANAK NIGEL`, position: `Manager - Insurance`, job_grade: `M1`, date_joined: ``},
{fullname: `CHONG SIAW HUA`, position: `Assistant Manager - Sales Admin`, job_grade: `NES6`, date_joined: ``},
{fullname: `FARAHANI BINTI HAINI`, position: `Executive - Sales`, job_grade: `E1`, date_joined: ``},
{fullname: `LAI SIAW LING`, position: `Officer - Purchasing`, job_grade: `E1`, date_joined: ``},
{fullname: `LESLIE LIM CHUNG LEONG`, position: `Manager - Operations`, job_grade: `M1`, date_joined: ``},
{fullname: `LING SHEAU WEI`, position: `QS`, job_grade: `E1`, date_joined: ``},
{fullname: `NGO JIN JIN`, position: `Assistant Manager - Purchasing`, job_grade: `E3`, date_joined: ``},
{fullname: `PHANG MING JING, RAINIE`, position: `Executive - Sales`, job_grade: `E1`, date_joined: ``},
{fullname: `SHARON NG KHE SWYN`, position: `Executive - Sales & Marketing`, job_grade: `E1`, date_joined: ``},
{fullname: `TAN YIEN LIN`, position: `Senior Officer - Admin`, job_grade: `NES5`, date_joined: ``},
{fullname: `THIAN FUI CHIUN, KERRY`, position: `Senior Officer - Admin`, job_grade: `NES5`, date_joined: ``},
{fullname: `TIE SHIE LING`, position: `Officer - Purchasing`, job_grade: `E1`, date_joined: ``},
{fullname: `TIEO SEOW LING, LYN`, position: `Senior Executive - Sales`, job_grade: `NES5`, date_joined: ``},
{fullname: `TING KWAN HEE`, position: `Manager - Admin cum Mall Operation`, job_grade: `M1`, date_joined: ``},
{fullname: `YEO TANG TANG`, position: `Executive - Office`, job_grade: `NES5`, date_joined: ``},
{fullname: `ALBINUS PETRUS RATIM NGIBAN`, position: `Officer - Admin`, job_grade: `NES4`, date_joined: ``},
{fullname: `ALI BIN SABRI`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `BONNIE ANAK ANTHONY`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `HAIDI BIN MARANI`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `TUNI ANAK OUI JUAN`, position: `Office Assistant`, job_grade: `NE1`, date_joined: ``},
{fullname: `JOHAN ANAK JAWA`, position: `Assistant Surveyor`, job_grade: `NES4`, date_joined: ``},
{fullname: `CHOO ZONGWEI`, position: `Assistant Accountant`, job_grade: `E3`, date_joined: ``},
{fullname: `CHUA YONG TIEN, EUNICE`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `CINDY CHONG LEE MING`, position: `Officer - Accounts`, job_grade: `NES4`, date_joined: ``},
{fullname: `JONG HUI WOON`, position: `Assistant Accountant`, job_grade: `E3`, date_joined: ``},
{fullname: `LAU LI KUO`, position: `Accountant`, job_grade: `M1`, date_joined: ``},
{fullname: `MICHELLE WONG XIU HAN`, position: `Officer - Costing`, job_grade: `E1`, date_joined: ``},
{fullname: `NG KHOON CHIENG`, position: `Senior Officer - Accounts`, job_grade: `NES5`, date_joined: ``},
{fullname: `SOH MEI XING`, position: `Accounts Assistant`, job_grade: `E1`, date_joined: ``},
{fullname: `TAN KAH HO, LEON`, position: `Accountant`, job_grade: `M1`, date_joined: ``},
{fullname: `VANESSA TAY MING FONG`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `JOYCE TEH YEE`, position: `Assistant Accountant`, job_grade: `E3`, date_joined: ``},
{fullname: `TERRY THAM TZE PING`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `TAY YI YING`, position: `Officer - Sales Admin`, job_grade: `E1`, date_joined: ``},
{fullname: `JACKUELINE ONG YUEN CHING`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `ONG CHIAW SIAN`, position: `Officer - Accounts`, job_grade: `NES4`, date_joined: ``},
{fullname: `ANNIE LEE SIEW PHIN`, position: `Officer - Accounts `, job_grade: `E1`, date_joined: ``},
{fullname: `CHAI LI SWAN`, position: `Senior Officer - Accounts/PA to TTY`, job_grade: `NES5`, date_joined: ``},
{fullname: `CHAI PEI SHAN`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `CHAI SIN HWEI`, position: `Manager - Accounts`, job_grade: `M1`, date_joined: ``},
{fullname: `CHIN JIUN HUAH, ANGEL`, position: `Officer - Corporate Secretarial / Legal`, job_grade: `E1`, date_joined: ``},
{fullname: `CHRISTABELLA DUIE ANAK CHRISTOPHER NYENGGANG`, position: `Clerk - Accounts`, job_grade: `NE2`, date_joined: ``},
{fullname: `JANICE ANG CI XIA`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `JI CHOU KING`, position: `Assistant Accountant`, job_grade: `E3`, date_joined: ``},
{fullname: `KHO BOON POH`, position: `Clerk - Accounts`, job_grade: `NE2`, date_joined: ``},
{fullname: `LIM EK HUA`, position: `Manager - Accts Admin`, job_grade: `M1`, date_joined: ``},
{fullname: `ONG CHIEW LING`, position: `Senior Officer - Accounts`, job_grade: `E2`, date_joined: ``},
{fullname: `SIA SOON GUEI`, position: `Manager - Accts Admin`, job_grade: `M1`, date_joined: ``},
{fullname: `SIM PEI CHUN`, position: `Officer - Accounts`, job_grade: `NES4`, date_joined: ``},
{fullname: `SIM SIAT FUNG, ALICE`, position: `Officer - Accounts`, job_grade: `NES4`, date_joined: ``},
{fullname: `TAN MIAW ENG, ANGELINE`, position: `Senior Officer - Accounts/PA to AL`, job_grade: `E2`, date_joined: ``},
{fullname: `WONG WOAN MIING, RACHELLE`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `YONG TING`, position: `Officer - Accounts`, job_grade: `E1`, date_joined: ``},
{fullname: `VOON JIEW MIN`, position: `Manager - Quarry Operations`, job_grade: `M1`, date_joined: ``},
{fullname: `BONG IT FIAN, IVAN`, position: `Plant Manager - Concrete`, job_grade: `M1`, date_joined: ``},
{fullname: `CHEE SIAW PAW`, position: `Operations Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `KHO HO SIA, GEORGE`, position: `Supervisor`, job_grade: `NES5`, date_joined: ``},
{fullname: `WONG MING`, position: `Plant Manager`, job_grade: `M1`, date_joined: ``},
{fullname: `MOHD SHAHRUL SHAH FENDI HENDY DVAI`, position: `Assistant Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `REMY ANAK JOHEL`, position: `Officer - QAQC cum Document Control`, job_grade: `E1`, date_joined: ``},
{fullname: `FABIANA ANAK CHAN`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `LIEGAN ANAK MANGGUH`, position: `Assistant Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `NOOR MARLIDAH HAI`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `BRIGETTE BRENDA BASE`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `CHENDANG ANAK THOMAS ALI`, position: `QA Technician`, job_grade: `NE2`, date_joined: ``},
{fullname: `CHIN LEE HUA`, position: `Admin Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `DIANA BIDAI ANAK MENDALI`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `JOHNNY HO KOK SIAM`, position: `Assistant Supervisor`, job_grade: `NES4`, date_joined: ``},
{fullname: `JONG KIM WONG`, position: `QA Technician`, job_grade: `NE2`, date_joined: ``},
{fullname: `JULLYANA GORILA ANAK JENOS`, position: `Admin Assistant`, job_grade: `NE2`, date_joined: ``},
{fullname: `LESTER LUNA ANAK ULOK`, position: `Technical Assistant`, job_grade: `NES4`, date_joined: ``},
{fullname: `MAINA NICKOLA ANAK MICHILE`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `NELVIN BRIAN ANAK NAWOT`, position: `Plant Supervisor`, job_grade: `NES5`, date_joined: ``},
{fullname: `NURUL HURAIRAH BINTI SARIP`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `SYLVESTER ANAK KENETH KANYAN`, position: `QA Technician`, job_grade: `NES4`, date_joined: ``},
{fullname: `VERONICA SULAN ANAK VINCENT`, position: `QA Technician`, job_grade: `NE2`, date_joined: ``},
{fullname: `VORNICA NAYAN ANAK NANANG`, position: `General Clerk`, job_grade: `NE2`, date_joined: ``},
{fullname: `EDWARD TENLEY AK FRANCIS KETIR`, position: `Officer - Shipping`, job_grade: `NES4`, date_joined: ``},
{fullname: `YUNG MEI HUA, MANDY`, position: `Officer - Admin & Purchasing`, job_grade: `E1`, date_joined: ``},
{fullname: `GASTON QION EMMANUEL AK GEORGE`, position: `Senior Officer - Software Developer`, job_grade: `NES5`, date_joined: ``},
{fullname: `LO JAK FATT, EVENCE`, position: `Senior Officer - IT cum Admin`, job_grade: `NES5`, date_joined: ``},
{fullname: `TAN KEENG LING`, position: `Officer - Software Developer`, job_grade: `NES4`, date_joined: ``},
{fullname: `YONG WEI TING`, position: `System Analyst`, job_grade: `E1`, date_joined: ``},
{fullname: `ABRAHAM CHUANG-CHYI TIONG`, position: `MarCom Lead`, job_grade: `E2`, date_joined: ``},
{fullname: `KATHERINE SONG`, position: `Manager - Design`, job_grade: `M1`, date_joined: ``},
{fullname: `SYLVIA ANAK CHAONG`, position: `Officer - Projects Facilitator`, job_grade: `NES5`, date_joined: ``},
{fullname: `YVONNE SHARON ANAK MIKOLDEN`, position: `Executive - Mall & Events`, job_grade: `E1`, date_joined: ``},

  {
    fullname: "AUGUSTINE LAW SEK HIAN",
    date_joined: "1/1/1996"
  },

  {
    fullname: "LAU KIING KANG, SIMON",
    date_joined: "1/1/1990"
  },
  
  {
    fullname: "LAWRENCE KONG",
    date_joined: "5/5/1999"
  },  


  {
    fullname: "TONY YU YUONG WEE",
    date_joined: "21/5/2003"
  },  

  {
    fullname: "WONG MING",
    date_joined: "27/8/2001"
  },  

  {
    fullname: "YU JI",
    date_joined: "11/4/2011"
  },    
];

export const COMPANY_STAFFS = [
  {staff: `FREDERICK CABUNGAN BANAWA`, company: `HOCK SENG LEE BERHAD`},{staff: `RITCHDINI JUNIAN ANAK FREDDIE`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHAI YI THUNG, CARSON`, company: `HOCK SENG LEE BERHAD`},
{staff: `FREDERICK CABUNGAN BANAWA`, company: `HOCK SENG LEE BERHAD`},
{staff: `JONG SUK FANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `LENOR JOYCE SASOY LEGASPI-BANAWA`, company: `HOCK SENG LEE BERHAD`},
{staff: `LIEW SZE YAH, NICOLE`, company: `HOCK SENG LEE BERHAD`},
{staff: `NGO KEH TOH, ANNIE`, company: `HOCK SENG LEE BERHAD`},
{staff: `OW WAN FOO, EDDIE`, company: `HOCK SENG LEE BERHAD`},
{staff: `DORIS ANAK WILSON ELAH`, company: `HOCK SENG LEE BERHAD`},
{staff: `HO AI CHIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `NORSAMSUDDIN ANAK BANGUN`, company: `HOCK SENG LEE BERHAD`},
{staff: `SITI HAJAR BINTI MOHD YUSOP`, company: `AF CONSTRUCTION SDN BHD`},
{staff: `ELLYZA EZLYN BINTI BLAISE`, company: `THE ART GALLERIA SDN BHD`},
{staff: `JENNY YU PICK HAI`, company: `HOCK SENG LEE BERHAD`},
{staff: `STEPHEN TAN SOON HONG`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `TAN KOK SAN, NICOLE`, company: `HOCK SENG LEE BERHAD`},
{staff: `TANG LING PING, JENNIFER`, company: `HOCK SENG LEE BERHAD`},
{staff: `TAY CHIOK KEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `TIONG TECK YIENG`, company: `HOCK SENG LEE BERHAD`},
{staff: `YONG SERN PIAT`, company: `HOCK SENG LEE BERHAD`},
{staff: `AZALIZA BINTI AMIN`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `ELLY ANAK WILFRED`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `HELMI BIN PUTEH`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `MARCOS ANAK WARREN SAOH`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `NGUANG KIM KIONG`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `NORBAYU BT MUKU`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `SABREE BIN SABU`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `VERONICA A/P NOED`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `DIANA LEE MEI MEI`, company: `HOCK SENG LEE BERHAD`},
{staff: `HASNIYATI HII BINTI ABDULLAH`, company: `HOCK SENG LEE BERHAD`},
{staff: `KATHERINE YII JOU PEI`, company: `HOCK SENG LEE BERHAD`},
{staff: `LAI CHEAU NEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `LIM WEI SING`, company: `HOCK SENG LEE BERHAD`},
{staff: `SYLVIA TANG CHUNG TIEN`, company: `HOCK SENG LEE BERHAD`},
{staff: `ALAUDDIN BIN OTHMAN`, company: `HOCK SENG LEE REALTY SDN BHD`},
{staff: `BONG ZHANG YING`, company: `HOCK SENG LEE BERHAD`},
{staff: `JULIAN ACHOI ANAK GANA`, company: `HOCK SENG LEE BERHAD`},
{staff: `MARVIN TARANG ANAK EDWARD`, company: `HOCK SENG LEE BERHAD`},
{staff: `NICHOLAS ANAK JANNIES`, company: `HOCK SENG LEE BERHAD`},
{staff: `RICKFIELD GEWONG`, company: `HSL LAND SDN BHD`},
{staff: `ROSLAN BIN ROSLI`, company: `HOCK SENG LEE REALTY SDN BHD`},
{staff: `CAMILLA MARCIA KEDUAK ANAK UNYUK`, company: `HOCK SENG LEE BERHAD`},
{staff: `CLINTON JAWA ANAK RICHARDLY`, company: `HOCK SENG LEE BERHAD`},
{staff: `COLIN MATHEW`, company: `HOCK SENG LEE BERHAD`},
{staff: `GARY MADANG ANAK UNDOM`, company: `HSL LAND SDN BHD`},
{staff: `MAGDALYNE LIZA UBANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `MOHAMAD HATTA BIN ROSIDI`, company: `HOCK SENG LEE BERHAD`},
{staff: `MUHAMMAD BIN SARIP`, company: `HOCK SENG LEE BERHAD`},
{staff: `SUTIANA ANAK JESUT`, company: `HSL LAND SDN BHD`},
{staff: `LAU SIE CHUNG`, company: `PLUDEC TRANSPORT SDN BHD`},
{staff: `TING SII KIONG`, company: `PLUDEC TRANSPORT SDN BHD`},
{staff: `CHRIS BRYAN ANAK NAWOT`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `FRAVELLYN LYNDAI ANAK BUMA`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `CHIN CHEE HAO`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `LEE JIE LING`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `LIM KIAN BENG`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `MUHAMMAD ALFIAN WIRA SEPTIAN`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `MARDHIAH BINTI WAHID`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `CHUA SIAW TED`, company: `HOCK SENG LEE BERHAD`},
{staff: `LESTINLEY LUIS ANAK LAWAI`, company: `HOCK SENG LEE BERHAD`},
{staff: `SHIRLEY WONG LEE SAN`, company: `HOCK SENG LEE BERHAD`},
{staff: `ANGELA WONG SIEW MEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `LORRAINE LIEW WOON FUNG`, company: `HOCK SENG LEE BERHAD`},
{staff: `ELSIE LEE SUK CHER`, company: `HOCK SENG LEE BERHAD`},
{staff: `EVELYN ANAK ANAU`, company: `HOCK SENG LEE BERHAD`},
{staff: `HANNA SANTARINA ANAK MAURICE`, company: `HOCK SENG LEE BERHAD`},
{staff: `KO LIAN CHUENG, KENNETH`, company: `HOCK SENG LEE BERHAD`},
{staff: `LAI SIEW LIEN`, company: `HOCK SENG LEE BERHAD`},
{staff: `MAC AUBREY ANAK MORIS @ MICHAEL`, company: `HOCK SENG LEE BERHAD`},
{staff: `JONG QIAO XUAN`, company: `HOCK SENG LEE BERHAD`},
{staff: `BONG JOO CHEE`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `DAUD BIN MAHMOR`, company: `HOCK SENG LEE BERHAD`},
{staff: `LAW DUEN SIONG`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `NANCY THU MEI SZE`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `NG WAN LI, WENDY`, company: `HOCK SENG LEE BERHAD`},
{staff: `NUR ASFIA BIN MOHAMAD DOLLAH`, company: `AF CONSTRUCTION SDN BHD`},
{staff: `TAY GUAN PHING`, company: `KENDREDGE SDN BHD`},
{staff: `WEE GUEK YIAN`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `WEI SZE NEI`, company: `HOCK SENG LEE BERHAD`},
{staff: `YUSUF BIN BAHARI`, company: `HOCK SENG LEE BERHAD`},
{staff: `LEE PING CHIONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `MELISA ANAK SURING`, company: `HOCK SENG LEE BERHAD`},
{staff: `MUHAMMAD AMIRUL RIDHZUAN STANNY`, company: `MEGADUTA SDN BHD`},
{staff: `TING YING SIEW`, company: `HOCK SENG LEE BERHAD`},
{staff: `DARREN JOSHUA LUNA ANAK MARVIN @ IMPI`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `ADEEBA ATHIRA BINTI BERAHIM`, company: `HOCK SENG LEE BERHAD`},
{staff: `DESMOND LEE TONG HOWE`, company: `HOCK SENG LEE BERHAD`},
{staff: `CALVIN GARAN ANAK GOHAN`, company: `HOCK SENG LEE BERHAD`},
{staff: `LING NGIE LEE, KELVIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `SIM YUH SHIUN`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHRISTOPHER CHAI KOH WEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `VELDA CHANG CHIA YIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `ABDUL WARITH BIN MOHAMMAD PHILIP`, company: `AF CONSTRUCTION SDN BHD`},
{staff: `ARCHIBAL CATIBOG MANANSALA`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHAI CHANG LECK, ERIC`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHIANG HENG HO`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHONG YU CHIAU`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `CHRIS HUDSON ANAK BUJANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `KELVIN CHAI HOCK JOI`, company: `HOCK SENG LEE BERHAD`},
{staff: `LEE KUET LUNG`, company: `HOCK SENG LEE BERHAD`},
{staff: `LIM KAI HENG`, company: `HOCK SENG LEE BERHAD`},
{staff: `SELINBIT ANAK MOS`, company: `HOCK SENG LEE BERHAD`},
{staff: `TOH JAG HUI`, company: `HOCK SENG LEE BERHAD`},
{staff: `TULIS ANAK CHANDANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `VIVIANA ONG ZHI JINN`, company: `HOCK SENG LEE BERHAD`},
{staff: `LIEW HOCK RUI`, company: `HOCK SENG LEE BERHAD`},
{staff: `TIBU ANAK DAUD`, company: `HOCK SENG LEE BERHAD`},
{staff: `ALVIN CHONG TZE HUI`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHAN HOOD SOO`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHIN YIAN CHON, ALSON`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `CHINDAI ANAK JOSEPH`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `HENG MUI KEE`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `HON JUN KHIONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `JIMENO JR. LUGUE JERUSALEM`, company: `HOCK SENG LEE BERHAD`},
{staff: `JONG SIAW FOONG, STEVEN`, company: `HOCK SENG LEE BERHAD`},
{staff: `KELVIN KANG KIAN LAI`, company: `HOCK SENG LEE BERHAD`},
{staff: `KELVIN YII SENG HUA`, company: `HOCK SENG LEE BERHAD`},
{staff: `LAU YUK SIONG, PHILIP`, company: `HOCK SENG LEE BERHAD`},
{staff: `SIAW WEN YIAP, MICHEAL`, company: `HOCK SENG LEE BERHAD`},
{staff: `SIM KAY CHIAN, STEPHEN`, company: `HOCK SENG LEE BERHAD`},
{staff: `TING SING HWA`, company: `HOCK SENG LEE BERHAD`},
{staff: `JULIAN LAU KHERR LOONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `LAU KIEW HING`, company: `HOCK SENG LEE BERHAD`},
{staff: `SIEW MING HUA`, company: `HOCK SENG LEE BERHAD`},
{staff: `SIM YIK CHWIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `ANDYANNA ANAK ADRIS`, company: `HOCK SENG LEE BERHAD`},
{staff: `JASCICA ANAK BAJAK`, company: `HSL MANAGEMENT SERVICES SDN BHD`},
{staff: `BOBIC IZACK ANAK RAJINOK`, company: `HOCK SENG LEE BERHAD`},
{staff: `CYNTHIA TANG JOCK YUN`, company: `AF CONSTRUCTION SDN BHD`},
{staff: `MICHELLE HON XUE YUN`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `VANESSA TING MEE JIUN`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `VIONNIE CHIEW SIEW LING`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `VOON LIK YONG`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `WENDY CHONG LEE YA`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `YAP LI LI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `YASMINE FATHIAH BINTI MOHD DEXTER HOWELL`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `BELINDA TAN CHAI YING`, company: `MEGADUTA SDN BHD`},
{staff: `BILLY JONG HUNG ENG`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `CHONG UU LEONG, ZACK`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `EMILY ANAK USAM`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `HELY ANAK SOTIN`, company: `ACEGRADE ENTERPRISE SDN BHD`},
{staff: `JOEL SU TAI TUNG`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `JOSEPHINE FOO SIEW PHENG`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `LIM SOO HUI`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `LING SHI HING, ERIC`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `MARIA JATTI ANAK ENA`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `MARIA SU`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `OLIZARENA ANAK ENA`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `THON HUI HUI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `TIONG SIEW LING`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `VOON SAY NYUK, SHIRLEY`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `WAN MOHAMAD BIN WAN ALLI`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `BONG MEI LUN`, company: `HOCK SENG LEE REALTY SDN BHD`},
{staff: `IDZWAN HAKIMI BIN TAHIR`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHIENG CHING KUOK`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `CHIENG SHAW YAW`, company: `HOCK SENG LEE REALTY SDN BHD`},
{staff: `CHONG CHIA WEI`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `DAVIDSON AK DAYUT`, company: `HOCK SENG LEE BERHAD`},
{staff: `FLONY MEREH ANAK DAVID`, company: `MEGADUTA SDN BHD`},
{staff: `GOH CHIN SING`, company: `HOCK SENG LEE REALTY SDN BHD`},
{staff: `JACKLYN ANAK JUGAH`, company: `HOCK SENG LEE BERHAD`},
{staff: `PERNANDEZ TULIS`, company: `HOCK SENG LEE BERHAD`},
{staff: `SYLVESTER MIKE LIEW CHO KEAT`, company: `HOCK SENG LEE BERHAD`},
{staff: `TANG SING HUI`, company: `HOCK SENG LEE BERHAD`},
{staff: `TEO TAI WEE, STEPHEN`, company: `HOCK SENG LEE REALTY SDN BHD`},
{staff: `ARIF BIN CHIK`, company: `HOCK SENG LEE BERHAD`},
{staff: `MOHAMMAD AZEIR BIN UMIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `RUSWAN ASWARI BIN YAHYA`, company: `HOCK SENG LEE BERHAD`},
{staff: `PRESCILLIA ANAK PHILIP`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `FIODA LEW SHIN YII`, company: `NEXT PHASE SDN BHD`},
{staff: `CHRISTIANA ROMINA ANAK JANIS`, company: `HOCK SENG LEE BERHAD`},
{staff: `DAYANG NUR AININA BINTI ABG MOHAMAD`, company: `HOCK SENG LEE BERHAD`},
{staff: `FADILLAH BTE ABDULLAH`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `HII CHUI YEN, IVY`, company: `HOCK SENG LEE BERHAD`},
{staff: `MONA KEDAYA ANAK STORY`, company: `HOCK SENG LEE BERHAD`},
{staff: `NAJA ANAK NYAUN`, company: `PN CONSTRUCTION SDN BHD`},
{staff: `SANDRA ANAK JAWING`, company: `HOCK SENG LEE BERHAD`},
{staff: `SONIA VIVIANI ANAK JANIS`, company: `HOCK SENG LEE BERHAD`},
{staff: `TING SIAW WEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `VOON KHENG HUA, VALERIE`, company: `HOCK SENG LEE BERHAD`},
{staff: `AMINAH BINTI ABIDIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHAI JIEW LEONG`, company: `KENDREDGE SDN BHD`},
{staff: `ADRIAN CHAI YOU QING`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `HO SIAW LEE, LILY`, company: `MEGAPRON ENGINEERING SDN BHD`},
{staff: `IRENE KHO AI LING`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `IRWAN BIN BUJANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `JOYCE LIM FAYE`, company: `HOCK SENG LEE BERHAD`},
{staff: `TANG KUI SIEW, DEBBY`, company: `HOCK SENG LEE BERHAD`},
{staff: `ANDRESS LANTUK ANAK MAJING`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `WINNIE LAI EE FEI`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `HII YII SHIN`, company: `BORNEO PALEM LESTARI SDN BHD`},
{staff: `ABDUL AZIZ BIN HIPENI`, company: `HOCK SENG LEE BERHAD`},
{staff: `ALYSSA ASONG SIMON`, company: `HOCK SENG LEE SERVICES SDN BHD`},
{staff: `LINDA ANAK BUYONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `VICTORIA ANAK UMPANG`, company: `MEGADUTA SDN BHD`},
{staff: `AARON AU SAU SIANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `ALEXANDER LAI HORNG WEN`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `ANGIE JOAN ANAK DANIEL`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `CHARLES LEE WEE TECK`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHARLES REYNOLD ANAK NIGEL`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHONG SIAW HUA`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `FARAHANI BINTI HAINI`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `LAI SIAW LING`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `LESLIE LIM CHUNG LEONG`, company: `BORNEO PALEM LESTARI SDN BHD`},
{staff: `LING SHEAU WEI`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `NGO JIN JIN`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `PHANG MING JING, RAINIE`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `SHARON NG KHE SWYN`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `TAN YIEN LIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `THIAN FUI CHIUN, KERRY`, company: `MEGAKINA SHIPPING SDN BHD`},
{staff: `TIE SHIE LING`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `TIEO SEOW LING, LYN`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `TING KWAN HEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `YEO TANG TANG`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `ALBINUS PETRUS RATIM NGIBAN`, company: `AF CONSTRUCTION SDN BHD`},
{staff: `ALI BIN SABRI`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `BONNIE ANAK ANTHONY`, company: `BORNEO GEOTECHNICAL ENGINEERING SDN BHD`},
{staff: `HAIDI BIN MARANI`, company: `MEGAKINA SHIPPING SDN BHD`},
{staff: `TUNI ANAK OUI JUAN`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `JOHAN ANAK JAWA`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHOO ZONGWEI`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHUA YONG TIEN, EUNICE`, company: `HOCK SENG LEE BERHAD`},
{staff: `CINDY CHONG LEE MING`, company: `HOCK SENG LEE BERHAD`},
{staff: `JONG HUI WOON`, company: `HOCK SENG LEE BERHAD`},
{staff: `LAU LI KUO`, company: `HOCK SENG LEE BERHAD`},
{staff: `MICHELLE WONG XIU HAN`, company: `HOCK SENG LEE BERHAD`},
{staff: `NG KHOON CHIENG`, company: `KENDREDGE SDN BHD`},
{staff: `SOH MEI XING`, company: `HOCK SENG LEE BERHAD`},
{staff: `TAN KAH HO, LEON`, company: `HOCK SENG LEE BERHAD`},
{staff: `VANESSA TAY MING FONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `JOYCE TEH YEE`, company: `HOCK SENG LEE BERHAD`},
{staff: `TERRY THAM TZE PING`, company: `RED DOT TUNNELLING SDN BHD`},
{staff: `TAY YI YING`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `JACKUELINE ONG YUEN CHING`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `ONG CHIAW SIAN`, company: `JENTERA CERIA SDN BHD`},
{staff: `ANNIE LEE SIEW PHIN`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHAI LI SWAN`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHAI PEI SHAN`, company: `HOCK SENG LEE TRADING SDN BHD`},
{staff: `CHAI SIN HWEI`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHIN JIUN HUAH, ANGEL`, company: `HOCK SENG LEE BERHAD`},
{staff: `CHRISTABELLA DUIE ANAK CHRISTOPHER NYENGGANG`, company: `HOCK SENG LEE BERHAD`},
{staff: `JANICE ANG CI XIA`, company: `HOCK SENG LEE TRADING SDN BHD`},
{staff: `JI CHOU KING`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `KHO BOON POH`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `LIM EK HUA`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `ONG CHIEW LING`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `SIA SOON GUEI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `SIM PEI CHUN`, company: `HOCK SENG LEE BERHAD`},
{staff: `SIM SIAT FUNG, ALICE`, company: `HOCK SENG LEE BERHAD`},
{staff: `TAN MIAW ENG, ANGELINE`, company: `HOCK SENG LEE BERHAD`},
{staff: `WONG WOAN MIING, RACHELLE`, company: `HOCK SENG LEE BERHAD`},
{staff: `YONG TING`, company: `HOCK SENG LEE BERHAD`},
{staff: `VOON JIEW MIN`, company: `PLUDEC STONES & CONSTRUCTION SDN BHD`},
{staff: `BONG IT FIAN, IVAN`, company: `POH YONG CONCRETE SDN BHD`},
{staff: `CHEE SIAW PAW`, company: `PLUDEC TRANSPORT SDN BHD`},
{staff: `KHO HO SIA, GEORGE`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `WONG MING`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `MOHD SHAHRUL SHAH FENDI HENDY DVAI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `REMY ANAK JOHEL`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `FABIANA ANAK CHAN`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `LIEGAN ANAK MANGGUH`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `NOOR MARLIDAH HAI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `BRIGETTE BRENDA BASE`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `CHENDANG ANAK THOMAS ALI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `CHIN LEE HUA`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `DIANA BIDAI ANAK MENDALI`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `JOHNNY HO KOK SIAM`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `JONG KIM WONG`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `JULLYANA GORILA ANAK JENOS`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `LESTER LUNA ANAK ULOK`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `MAINA NICKOLA ANAK MICHILE`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `NELVIN BRIAN ANAK NAWOT`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `NURUL HURAIRAH BINTI SARIP`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `SYLVESTER ANAK KENETH KANYAN`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `VERONICA SULAN ANAK VINCENT`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `VORNICA NAYAN ANAK NANANG`, company: `POH YONG TILES INDUSTRIES SDN BHD`},
{staff: `EDWARD TENLEY AK FRANCIS KETIR`, company: `AF CONSTRUCTION SDN BHD`},
{staff: `YUNG MEI HUA, MANDY`, company: `HOCK SENG LEE BERHAD`},
{staff: `GASTON QION EMMANUEL AK GEORGE`, company: `HOCK SENG LEE BERHAD`},
{staff: `LO JAK FATT, EVENCE`, company: `HOCK SENG LEE CONSTRUCTION SDN BHD`},
{staff: `TAN KEENG LING`, company: `HOCK SENG LEE MACHINERY SDN BHD`},
{staff: `YONG WEI TING`, company: `HOCK SENG LEE BERHAD`},
{staff: `ABRAHAM CHUANG-CHYI TIONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `KATHERINE SONG`, company: `HOCK SENG LEE BERHAD`},
{staff: `SYLVIA ANAK CHAONG`, company: `NEXT PHASE SDN BHD`},
{staff: `YVONNE SHARON ANAK MIKOLDEN`, company: `HOCK SENG LEE BERHAD`},
];

export const COMPANIES = [
 "HOCK SENG LEE BERHAD",
  "AF CONSTRUCTION SDN BHD",
  "THE ART GALLERIA SDN BHD",
  "MEGAPRON ENGINEERING SDN BHD",
  "POH YONG CONCRETE SDN BHD",
  "HOCK SENG LEE REALTY SDN BHD",
  "HSL LAND SDN BHD",
  "PLUDEC TRANSPORT SDN BHD",
  "BORNEO GEOTECHNICAL ENGINEERING SDN BHD",
  "PN CONSTRUCTION SDN BHD",
  "HOCK SENG LEE MACHINERY SDN BHD",
  "HOCK SENG LEE CONSTRUCTION SDN BHD",
  "KENDREDGE SDN BHD",
  "MEGADUTA SDN BHD",
  "PLUDEC STONES & CONSTRUCTION SDN BHD",
  "HSL MANAGEMENT SERVICES SDN BHD",
  "POH YONG TILES INDUSTRIES SDN BHD",
  "ACEGRADE ENTERPRISE SDN BHD",
  "NEXT PHASE SDN BHD",
  "BORNEO PALEM LESTARI SDN BHD",
  "HOCK SENG LEE SERVICES SDN BHD",
  "MEGAKINA SHIPPING SDN BHD",
  "RED DOT TUNNELLING SDN BHD",
  "JENTERA CERIA SDN BHD",
  "HOCK SENG LEE TRADING SDN BHD"
];
